// https://codepen.io/JEE42/pen/rNbLoxb

/*
https://pzppzz.github.io/konvajs-image-crop-demo/
https://blog.intzone.com/using-konva-js-to-annotate-image-with-bounding-boxes/
*/

let baseBoardConfig = {
  canChooseTrack: null,
  width: null,
  length: null
};

const baseUrl = "https://customcribboards.com/cdn/shop/files/";
const width = window.innerWidth;
const height = window.innerHeight;
//const width = container.offsetWidth;
//const height = container.offsetHeight;
const sceneWidth = width;
const sceneHeight = height;

const DPI = 96;
const CPM = 1.25;
const textFree = 2;
const perLane = 10;

let designName = "untitled";
const designNamePrefix = "customizer-";

let textObjects = new Array();
let boardImage = null;
let baseBoard = null;
let selectedNode = null;
const scaleBy = 1.1; // How much to zoom in/out with each scroll step
let intervalId;
let intervalDelay = 10;
let pressTimer;
const longPressDelay = 500; // milliseconds
let autoLoadDesign = true;
let engraveColor = "#1d0200";
let transparentColor = "transparent";
let lastFont = "Arial";
const inch = 72;
const resizeIncrement = inch;
const maxBaseBoardWidth = 24;  // in inches
const maxBaseBoardHeight = 16; // in inches
const boardFeetInches = 144; // 12in x 12in = 144in² per board foot

const GUIDELINE_OFFSET = 10; // Snap tolerance in pixels

let pegSizes = [
  {
    name: "1/8",
    value: 0.125,
    scale: 1
  },
  {
    name: "3/32",
    value: 0.09375,
    scale: .75
  },
  {
    name: "5/64",
    value: 0.078125,
    scale: .625
  },
  {
    name: "3/16",
    value: 0.1875,
    scale: 1.5
  },
  {
    name: "1/4",
    value: 0.25,
    scale: 2
  },
  {
    name: "3/8",
    value: 0.375,
    scale: 3
  },
  {
    name: "1/2",
    value: 0.5,
    scale: 4
  },
];
let boardDimensions = {
  board: {
    width: 0,
    height
  },
  base: {
    width: 0,
    height
  },
  transformer: {
    width: 0,
    height: 0
  },
  boardFeet: {
    total: 0
  }
};
let dropZone = null;


let rotSnaps = [];
for (let r = 0; r < 360; r += 45) {
  rotSnaps.push(r);
}

let stainFilters = [
  {
    name: "Clear"
  },
  {
    name: "Light Brown",
    red: 235,
    blue: 78,
    green: 152
  },
  {
    name: "Dark Brown",
    red: 55,
    blue: 4,
    green: 34
  },
  {
    name: "Gunstock",
    red: 255,
    blue: 31,
    green: 95
  },
  {
    name: "Grey",
    red: 160,
    blue: 160,
    green: 160
  },
  {
    name: "Ebony",
    red: 40,
    blue: 40,
    green: 40
  }
];

let contextMenuItems = [
  {
    icon: 'upload',
    title: 'Move Up',
    class: null,
    action: ctxMoveNodeUp
  },
  {
    icon: 'download',
    title: 'Move Down',
    class: null,
    action: ctxMoveNodeDown
  },

  {
    icon: 'center_focus_weak',
    title: 'Center',
    class: null,
    action: ctxCenter
  },
  {
    icon: 'copy_all',
    title: 'Duplicate',
    class: null,
    action: ctxDuplicate
  },

  {
    icon: 'flip',
    title: 'Flip Vertical',
    class: 'rotate90',
    action: ctxFlipVertical
  },
  {
    icon: 'flip',
    title: 'Flip Horizontal',
    class: null,
    action: ctxFlipHorizontal
  },

  {
    icon: 'rotate_left',
    title: 'Rotate Left',
    class: null,
    action: ctxRotateLeft
  },
  {
    icon: 'rotate_right',
    title: 'Rotate Right',
    class: null,
    action: ctxRotateRight
  },
  {
    icon: 'text_rotate_up',
    title: 'Increase Size',
    class: null,
    action: ctxIncreaseSize
  },
  {
    icon: 'text_rotate_vertical',
    title: 'Decrease Size',
    class: null,
    action: ctxDecreaseSize
  },
  {
    icon: 'delete_forever',
    title: 'Delete',
    class: null,
    action: ctxDelete
  },
];




const stage = new Konva.Stage({
  container: "container",
  width: width,
  height: height,
  draggable: true,
});
const layer = new Konva.Layer();
stage.add(layer);

let baseRotateSnaps = [];
for (let r = 0; r < 360; r += 90) {
  baseRotateSnaps.push(r);
}

const baseimagetransformer = new Konva.Transformer({
  selectable: false,
  flipEnabled: false,
  rotationSnaps: baseRotateSnaps,
  rotationSnapTolerance: 45,
  rotateAnchorOffset: 25,
  enabledAnchors: ['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'],
  //enabledAnchors: ['top-center'],
  //draggable: false,
  anchorStyleFunc: (anchor) => {
    anchor.cornerRadius(10);
    if (anchor.hasName("top-center") || anchor.hasName("bottom-center")) {
      anchor.height(6);
      anchor.offsetY(3);
      anchor.width(20);
      anchor.offsetX(13);
    } else if (anchor.hasName("middle-left") || anchor.hasName("middle-right")) {
      anchor.height(26);
      anchor.offsetY(13);
      anchor.width(6);
      anchor.offsetX(3);
    } else if (anchor.hasName("rotater")) {
      anchor.cornerRadius(10);
      anchor.width(20);
      anchor.height(20);
      anchor.offsetX(10);
      anchor.offsetY(10);
    } else {
      anchor.width(14);
      anchor.offsetX(8);
      anchor.height(14);
      anchor.offsetY(8);
    }
  },

  boundBoxFunc: (oldBox, newBox) => {
    newBox.width = Math.round(newBox.width / (resizeIncrement * stage.scaleX())) * (resizeIncrement * stage.scaleX());
    newBox.height = Math.round(newBox.height / (resizeIncrement * stage.scaleY())) * (resizeIncrement * stage.scaleY());

    if (newBox.width < inch) newBox.width = inch * stage.scaleX();
    if (newBox.height < inch) newBox.height = inch * stage.scaleY();

    //console.log("newBox", newBox);

    if (newBox.width > inch * maxBaseBoardWidth * stage.scaleX()) newBox.width = inch * maxBaseBoardWidth * stage.scaleX();
    if (newBox.height > inch * maxBaseBoardHeight * stage.scaleX()) newBox.height = inch * maxBaseBoardHeight * stage.scaleY();

    //console.log("boundBoxFunc", newBox.width/(inch*stage.scaleX()), newBox.height/(inch*stage.scaleY()));

    return newBox;
  },
});
baseimagetransformer.on('transformend', () => {
  console.log("transformend", Math.round(baseimagetransformer.size().width / inch / stage.scaleX()), Math.round(baseimagetransformer.size().height / inch / stage.scaleY()));
  updateBaseLayerDimensions(baseimagetransformer.size());
});
baseimagetransformer.rotateEnabled(true);
layer.add(baseimagetransformer);


function svgToDataURL(svgString) {
  const encodedSvg = encodeURIComponent(svgString);
  return `data:image/svg+xml;charset=utf-8,${encodedSvg}`;
}

const mySvgData = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#36B1F7"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"/></svg>';
const svgDataUrl = svgToDataURL(mySvgData);

Konva.Image.fromURL(svgDataUrl, (imageNode) => {
  // Set desired position and size for your icon
  imageNode.setAttrs({
    x: -19,
    y: -19,
    width: 36, // Adjust as needed
    height: 36, // Adjust as needed
    selectable: false,
  });

  // Add the image to your Konva layer
  baseimagetransformer.add(imageNode);
});




function updateBaseLayerDimensions(newBox) {
  console.log('updateBaseLayerDimensions', newBox);
  //debugger;


  let boardDims = {
    width: Math.round(newBox.width / (inch * stage.scaleX())),
    height: Math.round(newBox.height / (inch * stage.scaleY()))
  };
  let baseDims = {
    width: getBaseLayer().width(),
    height: getBaseLayer().height()
  };
  let transDims = {
    width: parseInt(newBox.width),
    height: parseInt(newBox.height)
  };
  let boardFeet = Math.ceil((boardDims.width * boardDims.height) / boardFeetInches);

  boardDimensions.board = boardDims;
  boardDimensions.base = baseDims;
  boardDimensions.transformer = transDims;
  boardDimensions.boardFeet.total = boardFeet;


  /*
  console.log(`
Board Width: ${boardDims.width}
Board Height: ${boardDims.height}
Board Width: ${baseDims.width}
Board Height: ${baseDims.height}
Transformer Width: ${transDims.width}
Transformer Height: ${transDims.height}
Scale: ${stageScale}
Transformer Width: ${transDims.width/stageScale}
Transformer Height: ${transDims.height/stageScale}
`);
  */

  //boardDetailsText.text(`Width: ${boardDims.width}"\nHeight: ${boardDims.height}"\nWidth: ${baseDims.width}\nHeight: ${baseDims.height}\nWidth: ${transDims.width}\nHeight: ${transDims.height}\nScale: ${stageScale}`);
  //boardDetailsText.text(`Width: ${boardDims.width}"\nHeight: ${boardDims.height}"\nBoard Feet:${boardFeet}\nPrice: $${calculateDesignCost()}`);
  if (boardImage) {
    console.log('updateBaseLayerDimensions', boardDimensions);
    //if (baseBoard.board_foot > 0) { 
    //document.querySelector(".board-content").innerHTML = `Board Details<br>Width: ${boardDims.width}"<br>Height: ${boardDims.height}"<br>Board Feet: ${boardFeet}<br>Price: $${calculateDesignCost()}`;
    //} else {
    document.querySelector(".board-content").innerHTML = `Board Details<br>Width: ${boardDimensions.board.width}"<br>Height: ${boardDimensions.board.height}"<br>Price: $${calculateDesignCost()}`;
    //}
  }
}


window.addEventListener('resize', () => {
  handleWindowResize();
});

function handleWindowResize() {
  stage.width(window.innerWidth);
  stage.height(window.innerHeight);
  //background.width(stage.width());
  //background.height(stage.height());

  fitLayerToStage();

  layer.draw();
}

function fitLayerToStage() {
  const stageWidth = stage.width();
  const stageHeight = stage.height();

  // Get the bounding box of all content in the layer
  const contentRect = layer.getClientRect({
    skipTransform: true, // Ignore current layer scale for accurate bounds
  });

  // Calculate scale to fit content within stage
  const scaleX = stageWidth / contentRect.width;
  const scaleY = stageHeight / contentRect.height;
  const scale = Math.min(scaleX, scaleY); // Preserve aspect ratio

  // Apply scale to layer
  layer.scale({ x: scale, y: scale });

  // Center the content
  const scaledWidth = contentRect.width * scale;
  const scaledHeight = contentRect.height * scale;

  //console.log(stageWidth, stageHeight, scaleX, scaleY, scale, scaledWidth, scaledHeight);

  layer.x((stageWidth - scaledWidth) / 2 - contentRect.x * scale);
  layer.y((stageHeight - scaledHeight) / 2 - contentRect.y * scale);

  // Redraw the layer
  layer.batchDraw();
}

// Create a Transformer
const transformer = new Konva.Transformer({
  selectable: false,
  rotationSnaps: rotSnaps,
  shouldOverdrawWholeArea: true
  //rotateAnchorOffset: -50,
  //enabledAnchors: ["bottom-right"],
  //centeredScaling: true
});
layer.add(transformer);

transformer.on("transform", () => {
  updateProperties();
});
transformer.on("transformed", () => {
  updateProperties();
});

Konva._fixTextRendering = true;








function parseBoolean(bool) {
  const str = bool ?? "";
  return str.trim().toLowerCase() === "true";
}


function setBaseBoardConfig(config) {
  baseBoardConfig = {
    canChooseTrack: parseBoolean(config.canChooseTrack) ?? null,
    width: config.width ?? null,
    length: config.length ?? null,
  };
}


function getCanAddTrack() {
  let ret = false;

  if (getBaseLayer()) {
    let name = getBaseLayer().getAttrs().name;

    customizer_boards.forEach(board => {
      if (board.board_image == name) {
        ret = board.can_choose_track;
      }
    });
  }

  return ret;
}


function getFirstNonEmptyOption(selectElement) {
  return document.getElementById("boardsDialog").querySelector("img").dataset.image;
}


function getFirstNonEmptyOptionDataset(selectElement) {
  return document.getElementById("boardsDialog").querySelector("img").dataset;
}


async function loadBaseBoard(name) {
  //console.log("loadBaseBoard", name);

  customizer_boards.forEach(board => {
    //console.log("loadBaseBoard checking", board.name.toLowerCase().trim(), "/", name.toLowerCase().trim());

    if (board.name.toLowerCase().trim() == name.toLowerCase().trim()) {
      //console.log("loadBaseBoard loading", board);
      loadBaseImage(board.board_image);
    }
  });
}


function loadBaseImage(imgName) {
  //console.log("loadBaseImage", imgName);

  Konva.Image.fromURL(baseUrl + imgName, (image) => {
    image.setAttrs({
      x: 60 + image.width() / 2,
      y: 60 + image.height() / 2,
      name: imgName,
      type: "baseImage",
      draggable: false,
    });

    const scale = scaleDownToImage(image);
    stage.scale({ x: scale, y: scale });

    image.offset({
      x: image.width() / 2,
      y: image.height() / 2,
    });

    //console.log(image.width(), image.height(), scale);
    //image.className = "BaseLayer";

    boardImage = image;
    layer.add(image);
    layer.children[layer.children.length - 1].moveToBottom();
    baseimagetransformer.nodes([image]);

    console.log("loadBaseImage", image);

    setTimeout(() => {
      updateBaseLayerDimensions(baseimagetransformer.size());
      updateProperties();
    }, 2000);

    //console.log("loadbaseimage", baseBoard);
    if (baseBoard) {
      if (!baseBoard.can_resize) {
        baseimagetransformer.enabledAnchors(['top-center']);
      } else {
        baseimagetransformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
      }
    }
  });
}


function getBaseBoard(name) {
  let ret = null;

  customizer_boards.forEach(board => {
    if (board.name.toLowerCase().trim() == name.toLowerCase().trim()) {
      ret = board;
    }
  });

  return ret;
}

// Function to scale down image by 72-pixel increments
function scaleDownToImage(image) {
  const currentWidth = image.width();
  const currentHeight = image.height();
  const padding = 50; // 50px padding on all sides
  const maxWidth = stage.width() - 2 * padding; // Account for left and right padding
  const maxHeight = stage.height() - 2 * padding; // Account for top and bottom padding

  // If image already fits within stage with padding, no need to scale
  if (currentWidth <= maxWidth && currentHeight <= maxHeight) {
    console.log('Image already fits within stage with padding.');
    return;
  }

  // Calculate aspect ratio
  const aspectRatio = image.width() / image.height();

  // Calculate scale to fit stage with padding
  const scaleToFitWidth = maxWidth / image.width();
  const scaleToFitHeight = maxHeight / image.height();
  // Use the smaller scale to ensure both dimensions fit
  let targetScale = Math.min(scaleToFitWidth, scaleToFitHeight);

  // Calculate target dimensions based on scale
  let targetWidth = image.width() * targetScale;
  let targetHeight = image.height() * targetScale;
  let scaleInc = 72 * stage.scaleX();

  // Snap to nearest 72-pixel increment (floor for scaling down)
  targetWidth = Math.floor(targetWidth / scaleInc) * scaleInc;
  targetHeight = Math.floor(targetHeight / scaleInc) * scaleInc;

  // Ensure non-zero dimensions
  if (targetWidth < scaleInc) targetWidth = scaleInc;
  if (targetHeight < scaleInc) targetHeight = scaleInc;

  // Recalculate scale based on snapped dimensions
  const newScaleX = targetWidth / image.width();
  const newScaleY = targetHeight / image.height();
  const newScale = Math.min(newScaleX, newScaleY); // Uniform scaling

  //console.log(`scale: ${newScale}`);
  return newScale;
}








function newDesign() {
  let delNodes = Array();
  let items = layer.getChildren();

  items.forEach((item) => {
    //if (item.className !== "Transformer" && item.attrs.type != "baseImage") {
    if (item.className !== "Transformer") {
      delNodes.push(item);
    }
  });

  //console.log("function: newDesign");
  //console.log("delNodes", delNodes);

  delNodes.forEach((node) => {
    node.destroy();
  });

  designName = "untitled";
  selectNode(null);
}


function deleteAllObjects() {
  let delNodes = Array();
  let items = layer.getChildren();

  items.forEach((item) => {
    if (item.className !== "Transformer" && item.attrs.type != "baseImage") {
      delNodes.push(item);
    }
  });

  //console.log("function: deleteAllObjects");
  //console.log("delNodes", delNodes);

  delNodes.forEach((node) => {
    node.destroy();
  });

  selectNode(null);
}


function fileSaveDesign() {
  let filename = prompt("Save as", designName);

  if (filename) {
    let designName = filename;

    if (doesDesignExist("customizer-" + designName)) {
      if (!confirm("A design with that name already exists. Okay to overwrite it?")) {
        return;
      }
    }

    //console.log("Save as JSON", layer.toJSON());
    let layerJson = JSON.parse(layer.toJSON());
    //console.log("Save as JSON.parse", layerJson);
    layerJson.name = designName;
    layerJson.image = trimCanvas().toDataURL({ pixelRatio: 2 });

    thumbRunner(layerJson).then(function (resizedImageDataURI) {
      //console.log(resizedImageDataURI);
    });
  }
}


function downloadDesign() {
  let filename = prompt("Save as", designName);

  if (filename) {

    //console.log("downloadDesign");
    //console.log(filename);

    let designName = filename;

    //console.log("Save as JSON", layer.toJSON());
    let layerJson = JSON.parse(layer.toJSON());
    //console.log("Save as JSON.parse", layerJson);
    layerJson.name = designName;
    //layerJson.image = trimCanvas().toDataURL({ pixelRatio: 2 });

    if (filename) {
      console.log("Download JSON", JSON.stringify(layerJson));
      let dataStr = "data:text/json;charset=utf-8," + JSON.stringify(layerJson);

      var dlAnchorElem = document.getElementById("downloadAnchorElem");
      dlAnchorElem.setAttribute("href", dataStr);
      dlAnchorElem.setAttribute("download", filename + ".json");
      dlAnchorElem.click();
    }
  }
}


function fileDownloadDesign() {
  let loadButton = document.getElementById("loadSavedDesign");
  let selList = document.getElementById("selectSavedDesign");
  let selIndex = selList.selectedIndex;
  let filename = null;

  if (selIndex >= 0) {
    document.getElementById("loadDialog").close();
    let selectedText = selList.options[selIndex].value;
    filename = selectedText;
  }

  if (filename) {
    let layerJson = loadDesignJSON(filename);
    console.log("Dopwnload JSON", JSON.stringify(layerJson));
    let dataStr = "data:text/json;charset=utf-8," + JSON.stringify(layerJson);

    var dlAnchorElem = document.getElementById("downloadAnchorElem");
    dlAnchorElem.setAttribute("href", dataStr);
    dlAnchorElem.setAttribute("download", filename + ".json");
    dlAnchorElem.click();
  }
}


function fileLoadDesign() {
  //document.getElementById("jsonFileInput").click();
  let saveDesigns = getLocalStorageDesigns();
  //console.log(saveDesigns);

  let selList = document.getElementById("selectSavedDesign");
  selList.length = 0;

  if (saveDesigns.length > 0) {
    saveDesigns.forEach((design) => {
      let newOption = new Option(design.replace('customizer-', ''), design);
      newOption.setAttribute("data-img", getLocalDesignThumbnail(design));
      selList.add(newOption);
    });

    let ssd = document.getElementById("selectSavedDesign");
    const changeEvent = new Event('change', { bubbles: true });
    ssd.dispatchEvent(changeEvent);

    document.getElementById("loadDialog").showModal();
  } else {
    showMessage("Notice", "No saved designs found.");
  }
}


function fileLoadSavedDesign() {
  let loadButton = document.getElementById("loadSavedDesign");
  let selList = document.getElementById("selectSavedDesign");
  let selIndex = selList.selectedIndex;

  if (selIndex >= 0) {
    document.getElementById("loadDialog").close();
    let selectedText = selList.options[selIndex].value;
    loadDesign(selectedText);
  }
}


function selectSaveDesign() {
  let selList = document.getElementById("selectSavedDesign");
  let selImage = document.getElementById("selectSavedDesignImage");
  let selIndex = selList.selectedIndex;

  if (selIndex >= 0) {
    let selectedImage = selList.options[selIndex].getAttribute("data-img");
    selImage.src = selectedImage;
  }
}


function fileDeleteSavedDesign() {
  let loadButton = document.getElementById("loadSavedDesign");
  let selList = document.getElementById("selectSavedDesign");
  let selIndex = selList.selectedIndex;

  if (selIndex >= 0) {
    if (confirm("Are you sure want to delete this saved design?")) {
      let selectedText = selList.options[selIndex].value;
      deleteSavedDesign(selectedText);
      document.getElementById("loadDialog").close();
    }
  }
}


function deleteSavedDesign(name) {
  localStorage.removeItem(name);
}


function fileProcessUploadedJsonFile() {
  document.getElementById("jsonFileInput").addEventListener("change", (event) => {
    console.log("jsonFileInput");

    const file = event.target.files[0]; // Get the selected file
    if (!file) {
      console.error("No file uploaded");
      return;
    }

    // Check if the file type is JSON (optional, but good practice)
    if (file.type !== "application/json" && file.type !== "application/pdf") {
      console.error("not a valid file type");
      return;
    }

    const reader = new FileReader();

    // What to do when the file is successfully read
    reader.onload = (e) => {
      const fileContents = e.target.result;

      try {
        const parsedJson = JSON.parse(fileContents);
        layerFromJSON(parsedJson);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }

      document.getElementById("jsonFileInput").value = "";
    };

    // What to do if an error occurs during reading
    reader.onerror = (e) => {
      console.error("FileReader error:", reader.error);
    };

    // Read the file as text
    reader.readAsText(file);
  });
}




function groupItemTypes(items) {
  let layers = {
    baseLayerNode: null,
    imageNodes: [],
    textNodes: [],
    shapeNodes: []
  };

  //console.log("group items", items);
  items.forEach((item) => {
    if ((item.className === "Image" && item.attrs.type == "baseImage") || item.className === "BaseLayer") {
      layers.baseLayerNode = item;

    } else if ((item.className === "Image" && item.attrs.type == "svgobject") || item.className === "Track") {
      layers.imageNodes.push(item);

    } else if (item.className === "Text" ||
      item.className === "QuadraticTextPathGroup" ||
      item.className === "BezierTextPathGroup" ||
      item.className === "SinewaveTextPath" ||
      item.className === "CircleTextPath" ||
      item.className === "EllipseTextPath" ||
      item.className === "RectangleTextPath" ||
      item.className === "SidedTextPath" ||
      item.className === "HeartTextPath" ||
      item.className === "StarTextPath" ||
      item.className === "TeardropTextPath" ||
      item.className === "SpiralTextPath"
    ) {
      layers.textNodes.push(item);

    } else if (item.className === "Rect" ||
      item.className === "Circle" ||
      item.className === "Ellipse" ||
      item.className === "Star" ||
      item.className === "Arrow" ||
      item.className === "Wedge" ||
      item.className === "Arc" ||
      item.className === "HeartShape" ||
      item.className === "TeardropShape" ||
      item.className === "RegularPolygon") {
      layers.shapeNodes.push(item);

    }
  });

  //console.log("groupItemTypes", layers);

  return layers;
}

function layerFromJSON(json) {
  //console.log("layerFromJSON", json);

  selectNode(null);

  designName = json.name;

  let items = layer.getChildren();
  items.forEach((item) => {
    if (item.className !== "Transformer") {
      item.destroy();
    }
  });

  let children = json.children;
  let groupedItems = groupItemTypes(children);
  promiseLoadDesign(groupedItems);
  //console.log("layerFromJSON children", children);
  return;

  children.forEach((item) => {
    console.log("layerFromJSON Add Item", item);

    //console.log(item);
    //console.log(item.className);
    //console.log(item.attrs);

    if (item.className === "Image" && item.attrs.type == "baseImage") {
      loadBaseImage(item.attrs.name);

    } else if (item.className === "Image" && item.attrs.type == "svgobject") {
      doGetSvgFromUrl(item.attrs.name, item.attrs);

    } else if (item.className === "Text") {
      createTextNode(item.attrs);

    } else if (item.className === "TextPath") {
      createTextPathNode(item.attrs);

    }
  });
}








function promiseLoadBaseLayerNode(items) {
  //console.log("promiseLoadBaseLayerNode", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    console.log("promiseLoadBaseLayerNode Image", items);
    loadBaseImage(items.baseLayerNode.attrs.name);
    //console.log("getBaseLayerScale: ", getBaseLayerScale());

    resolve(items);

  });
}


function promiseLoadImageNodes(items) {
  //console.log("promiseLoadImageNodes", items);
  //console.log("getBaseLayerScale:", getBaseLayerScale());
  //console.log("getBaseLayer:", getBaseLayer());
  //console.log("Layer:", layer);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.imageNodes.forEach((item) => {

      //console.log("promiseLoadImageNodes Add Item", item);

      if ((item.className === "Image" && item.attrs.type == "svgobject") || item.className === "Track") {
        promiseDoGetSvgFromUrl(item.attrs.name, item.attrs);
      }

    });

    resolve(items);
  });
}


async function promiseGetSvgStringFromUrl(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const svgString = await response.text();
    return svgString;
  } catch (error) {
    console.error("Error fetching SVG:", error);
    return null;
  }
}


function promiseDoGetSvgFromUrl(svgUrl, config) {
  //console.log("doGetSvgFromUrl get", svgUrl, config);

  promiseGetSvgStringFromUrl(svgUrl).then((svgString) => {
    if (svgString) {
      //console.log("doGetSvgFromUrl gotSvg", svgString);
      promiseAddSvgImage(svgString, config);
    }
  });
}


function promiseAddSvgImage(svgString, config) {
  //console.log("promiseAddSvgImage", config);

  const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "#37393B"), "stroke", "#37393B");
  const base64Svg = removeXmlDeclaration(btoa(unescape(encodeURIComponent(blackStr))));
  const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;

  Konva.Image.fromURL(dataUrl, (imageNode) => {
    imageNode.draggable(true);

    imageNode.setAttrs({
      type: config.type ?? "svgobject",
      name: config.name ?? "",
      group: config.group ?? "",
      numberLanes: parseInt(config.numberLanes) ?? 4,
      width: config.width ?? 100,
      height: config.height ?? 100,
      scaleX: config.scaleX ?? 1,
      scaleY: config.scaleY ?? 1,
      x: config.x ?? 60,
      y: config.y ?? 60,
      offsetX: config.offsetX ?? 0,
      offsetY: config.offsetY ?? 0,
      sortable: config.group === "Tracks" ? false : true,
    });

    layer.add(imageNode);
    //layer.children[layer.children.length-1].moveToBottom();
    //layer.children[0].moveUp();

    if (config.rotation) {
      imageNode.setRotation(config.rotation);
    }

    layer.batchDraw();

    selectNode(imageNode);

    resetTrackIndex();
  });
}


function promiseLoadTextNodes(items) {
  //console.log("promiseLoadTextNodes", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.textNodes.forEach((item) => {

      console.log("promiseLoadTextNodes Add Text item", item.className, item);

      switch (item.className) {

        case "Text":
          createTextNode(item.attrs);
          break;

        case "SinewaveTextPath":
          createSinewaveTextPathNode(item.attrs);
          break;

        case "CircleTextPath":
          createCircleTextPathNode(item.attrs);
          break;

        case "EllipseTextPath":
          createEllipseTextPathNode(item.attrs);
          break;

        case "RectangleTextPath":
          createRectangleTextPathNode(item.attrs);
          break;

        case "SidedTextPath":
          createSidedTextPathNode(item.attrs);
          break;

        case "HeartTextPath":
          createHeartTextPathNode(item.attrs);
          break;

        case "StarTextPath":
          createStarTextPathNode(item.attrs);
          break;

        case "TeardropTextPath":
          createTeardropTextPathNode(item.attrs);
          break;

        case "SpiralTextPath":
          createSpiralTextPathNode(item.attrs);
          break;

        case "BezierTextPathGroup":
          createBezierTextPathGroupNodde(item.attrs);
          break;

        case "QuadraticTextPathGroup":
          createQuadraticTextPathGroupNodde(item.attrs);
          break;

      }

    });

    resolve(items);

  });
}


function promiseLoadShapeNodes(items) {
  //console.log("promiseLoadTextPathNodes", items);

  //validates the data
  return new Promise(function (resolve, reject) {

    items.shapeNodes.forEach((item) => {

      console.log("promiseLoadShapeNodes Add Shape item", item.className, item);

      switch (item.className) {

        case "Rect":
          addShapeRectangle(item.attrs);
          break;

        case "Circle":
          addShapeCircle(item.attrs);
          break;

        case "Ellipse":
          addShapeEllipse(item.attrs);
          break;

        case "Star":
          addShapeStar(item.attrs);
          break;

        case "Arrow":
          addShapeArrow(item.attrs);
          break;

        case "RegularPolygon":
          addShapeMultiSided(item.attrs);
          break;

        case "Wedge":
          addShapeWedge(item.attrs);
          break;

        case "Arc":
          addShapeArc(item.attrs);
          break;

        case "HeartShape":
          addShapeHeart(item.attrs);
          break;

        case "TeardropShape":
          addShapeTeardrop(item.attrs);
          break;

      }

    });

    resolve(items);

  });
}


function promiseProcessBaseLayer(items) {
  //console.log("promiseProcessBaseLayer");

  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      //console.log("promiseProcessBaseLayer layer", layer);
      //console.log("promiseProcessBaseLayer getBaseLayer", getBaseLayer());
      //console.log("promiseProcessBaseLayer getBaseLayerScale", getBaseLayerScale());  
    }, 2000);

    resolve(items);
  });
}


function promiseScaleImages(items) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      //console.log("promiseScaleImages");
      //c//consoleonsole.log("promiseScaleImages layer", layer);
      //console.log("promiseScaleImages getBaseLayer", getBaseLayer());
      //console.log("promiseScaleImages getBaseLayerScale", getBaseLayerScale());  

      let images = getImageLayers();
      //console.log("images", images);

      images.forEach((img) => {
        img.scale({
          x: getBaseLayerScale() - (img.getScaleX() * getBaseLayerScale()),
          y: getBaseLayerScale() - (img.getScaleY() * getBaseLayerScale())
        });
      });

      layer.batchDraw();
    }, 2000);

    resolve(items);
  });
}


//The function that orchestrates these calls 
function promiseLoadDesign(items) {
  //console.log("promiseLoadDesign", items);

  return promiseLoadBaseLayerNode(items)
    .then(promiseProcessBaseLayer)
    .then(promiseLoadImageNodes)
    .then(promiseLoadTextNodes)
    .then(promiseLoadShapeNodes)
  //.then(promiseScaleImages)
}


function getImageLayers() {
  let ret = new Array();

  layer.children.forEach((obj) => {
    if (obj.attrs.type === "svgobject") {
      ret.push(obj);
    }
  });

  return ret;
}


function saveDesignAsImage() {
  let filename = prompt("Save as", designName);

  if (filename) {
    designName = filename;

    baseimagetransformer.hide();
    transformer.hide();

    /*
    const dataURL = stage.toDataURL({
      pixelRatio: 2, // double resolution
    });
    */

    let ratio = 2;
    if (stage.width() < 768) {
      ratio = 5;
    }

    /*
    const dataURL = trimCanvas().toDataURL({
      pixelRatio: ratio, // double resolution
    });
    */
    let dataURL = stage.toDataURL({
      pixelRatio: ratio, // Adjust this value for higher resolution
      mimeType: 'image/png'
    });
    dataURL = removeTransparentBorders(dataURL, filename);
    /*
    console.log("dataURL", dataURL);

    console.log("Ratio", ratio);

    // create link to download
    const link = document.createElement("a");
    link.download = filename + ".png";
    link.href = dataURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    */

    baseimagetransformer.show();
    transformer.show();
  }
};


var trimCanvas = (function () {
  function rowBlank(imageData, width, y) {
    for (var x = 0; x < width; ++x) {
      if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
    }
    return true;
  }

  function columnBlank(imageData, width, x, top, bottom) {
    for (var y = top; y < bottom; ++y) {
      if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
    }
    return true;
  }

  return function (canvas) {
    var canvas = stage.toCanvas();
    var ctx = canvas.getContext("2d");
    var width = canvas.width;
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var top = 0, bottom = imageData.height, left = 0, right = imageData.width;

    while (top < bottom && rowBlank(imageData, width, top)) ++top;
    while (bottom - 1 > top && rowBlank(imageData, width, bottom - 1)) --bottom;
    while (left < right && columnBlank(imageData, width, left, top, bottom)) ++left;
    while (right - 1 > left && columnBlank(imageData, width, right - 1, top, bottom)) --right;

    var trimmed = ctx.getImageData(left, top, right - left, bottom - top);
    var copy = canvas.ownerDocument.createElement("canvas");
    var copyCtx = copy.getContext("2d");
    copy.width = trimmed.width;
    copy.height = trimmed.height;
    copyCtx.putImageData(trimmed, 0, 0);

    return copy;
  };
})();


function removeTransparentBorders(dataUrl, filename) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      console.log("removeTransparentBorders image", canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      let minX = canvas.width, minY = canvas.height;
      let maxX = 0, maxY = 0;

      // Find the bounding box of non-transparent pixels
      for (let y = 0; y < canvas.height; y++) {
        for (let x = 0; x < canvas.width; x++) {
          const alpha = data[((y * canvas.width + x) * 4) + 3];
          if (alpha > 0) { // If not fully transparent
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }

      // Calculate new dimensions and draw trimmed image
      const trimmedWidth = maxX - minX + 1;
      const trimmedHeight = maxY - minY + 1;
      console.log("removeTransparentBorders trimmed", trimmedWidth, trimmedHeight);

      if (trimmedWidth <= 0 || trimmedHeight <= 0) {
        // Image is entirely transparent or invalid
        resolve(dataUrl);
        return;
      }

      const trimmedCanvas = document.createElement('canvas');
      const trimmedCtx = trimmedCanvas.getContext('2d');
      trimmedCanvas.width = trimmedWidth;
      trimmedCanvas.height = trimmedHeight;

      trimmedCtx.drawImage(img, minX, minY, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);

      console.log("removeTransparentBorders trimmedCanvas", trimmedCanvas.toDataURL());

      const link = document.createElement("a");
      //let filename = "Untitled";
      link.download = filename + ".png";
      link.href = trimmedCanvas.toDataURL();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      baseimagetransformer.show();
      transformer.show();

      resolve(trimmedCanvas.toDataURL());
    };
    img.src = dataUrl;
  });
}






// 2nd drop down menu ( Add )
function openSelectTrackDialog() {
  let bl = getBaseLayer();

  if (!bl) {
    showMessage("Notice", "You must select a board before you pick a track.");
  } else if (bl && getCanAddTrack(bl.attrs.name) == false) {
    showMessage("Notice", "This cribbage board does not allow for custom tracks.");
  } else {
    document.getElementById("tracksDialog").showModal();
  }
}


function createTextNode(attrs) {
  console.log("createTextNode", attrs);
  console.log("getBaseLayer", getBaseLayer());

  /*
  let basePos = {
    x: getBaseLayer().getX(), 
    y: getBaseLayer().getY()
  };
  if (attrs && attrs.x) {
    basePos.x = attrs.x;
    basePos.y = attrs.y;
  }
  console.log("createTextNode", basePos);
  */

  let basePos = {
    x: 100,
    y: 100
  };

  const newText = new Konva.Text({
    offsetX: 0,
    offsetY: 0,
    x: attrs.x ?? basePos.x,
    y: attrs.y ?? basePos.y,
    text: attrs.text ?? "Custom Text",
    fontSize: attrs.fontSize ?? 40,
    fontFamily: attrs.fontFamily ?? lastFont,
    fontStyle: attrs.fontStyle ?? "normal",

    fill: "#1d0200",
    draggable: false,
    align: "center",
    type: "text",
    direction: attrs.direction ?? "Horizontal",
    sortable: true,
  });


  /*
  newText.shadowColor("rgba(255, 255, 255, 0.2)");
  newText.shadowOffset({ x: 0, y: 2 });
  newText.shadowBlur(2);

  newText.shadowColor("rgba(0, 0, 0, 0.7)");
  newText.shadowOffset({ x: 0, y: -2 });
  newText.shadowBlur(2);
  */

  layer.add(newText);
  newText.zIndex(getNextNodePos());

  if (attrs.rotation) {
    newText.setRotation(attrs.rotation);
  }

  selectNode(newText);
}


function createTextPathNode(attrs = {}) {
  //console.log("baseLayer", getBaseLayer());
  let baseCR = getBaseLayer().getClientRect();

  const newText = new Konva.TextPath({
    x: attrs.x ?? -((baseCR.width / 2) - (baseCR.x * 2)),
    y: attrs.y ?? -((baseCR.height / 2) - (baseCR.y * 2)),
    text: attrs.text ?? "CUSTOM TEXT",
    fontSize: attrs.fontSize ?? 20,
    fontFamily: attrs.fontFamily ?? lastFont,
    fontStyle: attrs.fontStyle ?? "normal",
    data: attrs.data ?? describeArc(400, 400, (attrs.fontSize ?? 20) * 6, 90, 0),
    angle: attrs.angle ?? 90,
    letterSpacing: attrs.letterSpacing ?? 1,
    draggable: false,
    fill: "#1d0200",
    align: "center",
    type: "textpath",
  });

  newText.shadowColor("rgba(255, 255, 255, 0.2)");
  newText.shadowOffset({ x: 0, y: 2 });
  newText.shadowBlur(2);

  newText.shadowColor("rgba(0, 0, 0, 0.7)");
  newText.shadowOffset({ x: 0, y: -2 });
  newText.shadowBlur(2);

  if (attrs.rotation) {
    newText.setRotation(attrs.rotation);
  }

  newText.on("dblclick dbltap", (evt) => {
    let id = evt.target.attrs.id;
    let sel = getSelectedNode();

    let newText = prompt("New Text", sel.text());
    if (newText) {
      sel.text(newText);
    }
  });

  layer.add(newText);
  selectNode(newText);
}


function createQuadraticTextPathGroupNodde(attrs = {}) {
  let quad = new QuadraticTextPathGroup({
    x: 200,
    y: 200,
    sortable: true,
  });
  layer.add(quad);
  quad.zIndex(getNextNodePos());
  quad.moveToTop();
  selectNode(quad);
  //console.log(quad1);
}


function createBezierTextPathGroupNodde(attrs = {}) {
  let bez = new BezierTextPathGroup({
    textPath: {
      text: "CUSTOM TEXT CUSTOM TEXT",
    },
    sortable: true,
  });
  layer.add(bez);
  bez.zIndex(getNextNodePos());
  bez.moveToTop();
  selectNode(bez);
  //console.log("bezier", bez1);
}


function createSinewaveTextPathNode(attrs = {}) {
  const myNode = new SinewaveTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    amplitude: attrs.amplitude ?? 80,
    frequency: attrs.frequency ?? 120,
    waves: attrs.waves ?? 3,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createCircleTextPathNode(attrs = {}) {
  const myNode = new CircleTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    radius: attrs.radius ?? 150,
    rotation: attrs.rotation ?? 0,
    canResize: true,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createEllipseTextPathNode(attrs = {}) {
  const myNode = new EllipseTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    radiusX: attrs.radiusX ?? 200,
    radiusY: attrs.radiusY ?? 100,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createRectangleTextPathNode(attrs = {}) {
  const myNode = new RectangleTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text 123',
    rectangleWidth: attrs.rectangleWidth ?? 400,
    rectangleHeight: attrs.rectangleHeight ?? 200,
    rectangleRadius: attrs.rectangleRadius ?? 20,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createSidedTextPathNode(attrs = {}) {
  const myNode = new SidedTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    radius: attrs.radius ?? 200,
    sides: attrs.sides ?? 6,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createHeartTextPathNode(attrs = {}) {
  const myNode = new HeartTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    width: attrs.width ?? 300,
    height: attrs.height ?? 300,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createStarTextPathNode(attrs = {}) {
  const myNode = new StarTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    width: attrs.width ?? 300,
    height: attrs.height ?? 300,
    points: attrs.points ?? 5,
    radius: attrs.radius ?? 0.5,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createTeardropTextPathNode(attrs = {}) {
  const myNode = new TeardropTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    width: attrs.width ?? 250,
    height: attrs.height ?? 400,
    rotation: attrs.rotation ?? 0,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}


function createSpiralTextPathNode(attrs = {}) {
  const myNode = new SpiralTextPath({
    x: attrs.x ?? 50,
    y: attrs.y ?? 50,
    fill: engraveColor,
    fontSize: attrs.fontSize ?? 24,
    fontFamily: attrs.fontFamily ?? lastFont,
    text: attrs.text ?? 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
    startRadius: attrs.startRadius ?? 10,
    endRadius: attrs.endRadius ?? 250,
    revolutions: attrs.revolutions ?? 4,
    sortable: true,
  });
  //console.log("myNode", myNode);
  layer.add(myNode);
  myNode.zIndex(getNextNodePos());
  selectNode(myNode);
}




function addShapeRectangle(attrs = {}) {
  let shape = new Konva.Rect({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    width: attrs.width ?? 200,
    height: attrs.height ?? 200,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    cornerRadius: attrs.cornerRadius ?? 10,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeCircle(attrs = {}) {
  let shape = new Konva.Circle({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    radius: attrs.radius ?? 100,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeEllipse(attrs = {}) {
  let shape = new Konva.Ellipse({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    radius: attrs.radius ?? 20,
    radiusX: attrs.radiusX ?? 100,
    radiusY: attrs.radiusY ?? 50,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeStar(attrs = {}) {
  let shape = new Konva.Star({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    numPoints: attrs.numPoints ?? 5,
    innerRadius: attrs.innerRadius ?? 50,
    outerRadius: attrs.outerRadius ?? 100,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  console.log("pos", getNextNodePos());
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeArrow(attrs = {}) {
  let shape = new Konva.Arrow({
    stroke: engraveColor,
    fill: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    points: attrs.points ?? [0, 0, 200, 0],
    pointerLength: attrs.pointerLength ?? 20,
    pointerWidth: attrs.pointerWidth ?? 20,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeMultiSided(attrs = {}) {
  let shape = new Konva.RegularPolygon({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    sides: attrs.sides ?? 6,
    radius: attrs.radius ?? 150,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeWedge(attrs = {}) {
  let shape = new WedgeShape({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    angle: attrs.angle ?? 22.5,
    radius: attrs.radius ?? 300,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeArc(attrs = {}) {
  let shape = new Konva.Arc({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    angle: attrs.angle ?? 22.5,
    innerRadius: attrs.innerRadius ?? 200,
    outerRadius: attrs.outerRadius ?? 400,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeHeart(attrs = {}) {
  let shape = new HeartShape({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    width: attrs.width ?? 200,
    height: attrs.height ?? 200,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}


function addShapeTeardrop(attrs = {}) {
  let shape = new TeardropShape({
    stroke: engraveColor,
    strokeWidth: attrs.strokeWidth ?? 5,
    width: attrs.width ?? 200,
    x: attrs.x ?? 200,
    y: attrs.y ?? 200,
    draggable: false,
    sortable: true,
  });

  layer.add(shape);
  shape.zIndex(getNextNodePos());
  selectNode(shape);
}




function wavesInputUpdated() {
  let waves = parseInt(document.getElementById("wavesInput").value);
  let amplitude = parseInt(document.getElementById("waveHeightInput").value);
  let frequency = parseInt(document.getElementById("waveWidthInput").value);

  if (selectedNode.className === "SinewaveTextPath") {
    selectedNode.waves(waves);
    selectedNode.amplitude(amplitude);
    selectedNode.frequency(frequency);
    selectedNode.updatePath();
    layer.batchDraw();
  }
}



// Upload Image
// Process uploaded image
document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("imageFileInput").addEventListener("change", (event) => {
    const file = event.target.files[0]; // Get the selected file

    if (!file) {
      console.error("No file uploaded");
      return;
    }

    // Check if the file type is an image
    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/png" &&
      file.type !== "image/webp" &&
      file.type !== "image/svg+xml"
    ) {
      console.error("not a valid file image type");
      return;
    }

    const reader = new FileReader();

    // What to do when the file is successfully read
    reader.onload = (e) => {
      const fileContents = e.target.result;

      if (file.type === "image/svg+xml") {
        //img = fileContents;
        addSvgImage(arrayBufferToUtf8String(fileContents), 60 + getBaseLayer().width() / 2, 60 + getBaseLayer().height() / 2);
        return;
      }

      const blob = new Blob([fileContents], { type: file.type });
      const imageUrl = URL.createObjectURL(blob);
      let img = new Image();

      img.onload = () => {
        let loadedImage = null;

        // 5. Create Konva.Image after HTMLImageElement is loaded
        loadedImage = new Konva.Image({
          x: 60 + getBaseLayer().width() / 2,
          y: 60 + getBaseLayer().height() / 2,
          image: img,
          width: img.width, // Use original image dimensions
          height: img.height,
          draggable: false,
          name: "uploadedImage",
          type: "imageupload",
        });

        // Optional: Scale down if image is too large for the stage
        const maxDimension = Math.max(img.width, img.height);
        const stageMax = Math.min(stage.width(), stage.height());
        if (maxDimension > stageMax * 0.8) {
          // If image is larger than 80% of stage
          const scale = (stageMax * 0.8) / maxDimension;
          loadedImage.width(img.width * scale);
          loadedImage.height(img.height * scale);
        }

        loadedImage.offset({
          x: loadedImage.width() / 2,
          y: loadedImage.height() / 2,
        });

        layer.add(loadedImage);
        loadedImage.filters([
          Konva.Filters.Grayscale,
          Konva.Filters.WhiteToTransparent,
        ]);
        loadedImage.cache();
        layer.draw();

        //layer.children[layer.children.length-1].moveToBottom();
        //layer.children[0].moveUp();

        selectNode(loadedImage);

        // IMPORTANT: Revoke the Object URL to release memory when the image is no longer needed
        // or when the page is unloaded. For this example, we'll revoke it immediately
        // as the HTMLImageElement has now loaded the data. If you needed the URL
        // for other purposes, you might revoke it later.
        URL.revokeObjectURL(imageUrl);
      };

      img.onerror = () => {
        statusDiv.textContent = "Error loading image from URL.";
        statusDiv.classList.add("error");
        URL.revokeObjectURL(imageUrl); // Revoke even on error
      };

      img.src = imageUrl; // Set the image source

      document.getElementById("imageFileInput").value = "";
    };

    // What to do if an error occurs during reading
    reader.onerror = (e) => {
      console.error("FileReader error:", reader.error);
    };

    // Read the file as binary
    reader.readAsArrayBuffer(file);
  });
});




// 3rd drop down menu ( Edit )
function duplicateNode() {
  let sel = getSelectedNode();

  if (sel && sel.attrs.type != "baseImage" && sel.attrs.group != "Tracks") {
    let cloned = sel.clone();
    layer.add(cloned);

    if (cloned.className === "Image") {
      cloned.filters([
        Konva.Filters.Grayscale,
        Konva.Filters.WhiteToTransparent,
      ]);
      cloned.cache();
      layer.draw();
    }
    selectNode(cloned);
  }
}


function handleKeyPress(event) {
  if (event.key === 'Delete') {
    handleDeleteItem()
  } else if (event.key === 'Insert') {
    createTextNode({});
  }
}


function handleDeleteItem() {
  let sel = getSelectedNode();

  if (sel && sel.attrs.type == "baseImage") {
    showMessage("Notice", "You can no delete the Cribbage board. Please select a new Cribbage board if this is not the one you want.")
  } else if (sel) {
    let selIdx = getNodeIndex(selectedNode);
    selectNode(null);
    deleteNode(sel);


    if (selIdx + 1 > layer.children.length) {
      selIdx = layer.children.length - 1;
      selIdx = getFirstSelectableNodeIndex();
    }

    if (selIdx != -1) {
      selectNode(layer.children[selIdx]);
    }
  }
}


function getNodeIndex(input) {
  let node = input;
  if (typeof input === 'number' || typeof input === 'string') {
    node = getNodeById(input);
  }

  if (node) {
    return node.zIndex();
  }
  return -1;
}

function getNodeById(id) {
  const findRecursive = (parent) => {
    if (parent._id === id) return parent;
    if (parent.children) {
      for (let child of parent.children) {
        let res = findRecursive(child);
        if (res) return res;
      }
    }
    return null;
  }
  return findRecursive(layer);
}


function getNextNode(node) {
  let nodeIdx = getNodeIndex(node) + 1;

  if (nodeIdx == layer.children.lendth) {
    nodeIdx == getFirstSelectableNodeIndex();
    console.log("nodeIdx-1", nodeIdx);
    if (nodeIdx == -1) {
      nodeIdx = null;
    }
    console.log("nodeIdx-2", nodeIdx);
    selectNode(nodeIdx);
  }
}


function getFirstSelectableNodeIndex() {
  let idx = -1;
  let pos = 0;

  layer.children.forEach(item => {
    if ((item.getClassName() !== "Image" && item.attrs.type !== "baseImage") && item.getClassName() != "Transformer") {
      if (idx === -1) {
        idx = pos;
      }
    }
    pos++;
  });

  return idx;
}


/* Add one or more listeners to an element
 ** @param {DOMElement} element - DOM element to add listeners to
 ** @param {string} eventNames - space separated list of event names, e.g. 'click change'
 ** @param {Function} listener - function to attach for each event as a listener
 */
function addMultipleEventListener(element, eventNames, listener) {
  var events = eventNames.split(" ");
  for (var i = 0, iLen = events.length; i < iLen; i++) {
    element.addEventListener(events[i], listener, false);
  }
}

addMultipleEventListener(document, "mouseup touchend", releaseInterval);
function releaseInterval() {
  if (intervalId) {
    clearInterval(intervalId); // Stop the interval
    intervalId = null; // Reset the interval ID
  }
}

addMultipleEventListener(
  document.getElementById("edit_rotate_left"),
  "mousedown touchstart",
  handleRotateLeft
);
function handleRotateLeft() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(rotateSelectedLeft, intervalDelay);
}

document.getElementById("edit_rotate_left").addEventListener("click", () => {
  rotateSelectedLeft();
});


addMultipleEventListener(
  document.getElementById("edit_rotate_right"),
  "mousedown touchstart",
  handleRotateRight
);
function handleRotateRight() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(rotateSelectedRight, intervalDelay);
}

document.getElementById("edit_rotate_right").addEventListener("click", () => {
  rotateSelectedRight();
});


addMultipleEventListener(
  document.getElementById("edit_increase_size"),
  "mousedown touchstart",
  handleScaleUpButton
);
function handleScaleUpButton() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(scaleUpObject, intervalDelay);
}


addMultipleEventListener(
  document.getElementById("edit_decrease_size"),
  "mousedown touchstart",
  handleScaleDownButton
);
function handleScaleDownButton() {
  if (intervalId) {
    clearInterval(intervalId);
  }
  intervalId = setInterval(scaleDownObject, intervalDelay);
}


function rotateSelectedLeft() {
  rotateObject(getSelectedNode(), 1);
}
function rotateSelectedRight() {
  rotateObject(getSelectedNode(), -1);
}
function rotateObject(obj, amount = 1) {
  if (obj) {
    obj.rotation(obj.rotation() + amount);
    updateProperties();
  }
}

function scaleUpObject() {
  scaleObject(getSelectedNode() ?? stage, 0.01);
}
function scaleDownObject() {
  scaleObject(getSelectedNode() ?? stage, -0.01);
}
function scaleObject(obj, amount = 0.01) {
  if (obj && canResize(obj)) {
    let newScale = obj.scaleX() + amount;
    obj.scale({ x: newScale, y: newScale });
    updateProperties();
  }
}










function destroyTrack() {
  let track = getTrack();
  if (track) {
    track.destroy();
    selectNode(null);
  }
}


document.getElementById("align").addEventListener("change", function () {
  let sel = getSelectedNode();
  let align = document.getElementById("align").value;

  if (sel) {
    sel.setAlign(align);
  }
});


document.getElementById("fontFamily").addEventListener("change", function () {
  let sel = getSelectedNode();
  let external = document.getElementById("fontFamily").getAttribute("data-external");
  //console.log("New Font", fontSelect.value);

  const ffSelect = document.getElementById('fontFamily');
  const ffSelected = ffSelect.options[ffSelect.selectedIndex];
  const ffExternal = ffSelected.getAttribute('data-family');
  //console.log("family", ffSelected.value, ffExternal);
  lastFont = ffSelected.value;

  if (sel) {
    //if (sel.fontFamily != undefined) {
    if (ffExternal !== null) {
      //console.log("Loading Google Font")
      loadGoogleFont(ffExternal, ffSelected.value);

      //console.log("Loaded Google Font")
      layer.batchDraw();
      //console.log("Redraw After Loaded Google Font")
    } else {
      sel.setFontFamily(ffSelected.value);
      layer.batchDraw();
    }
    //}
  }
});

async function loadGoogleFont(family, name) {
  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = "https://fonts.googleapis.com/css2?display=swap&family=" + family;
  link.onload = () => {
    //console.log('loadGoogleFont Loaded');

    let sel = getSelectedNode();
    if (sel) {
      //console.log('setTimeout Google Font', name);
      sel.setFontFamily(name);
      //layer.batchDraw();
      setTimeout(() => {
        layer.batchDraw();
      }, 500);
    }

  };
  document.getElementsByTagName('head')[0].appendChild(link);
}


function getSelectedNode() {
  return selectedNode;
}


function deleteNode(obj) {
  if (obj) {
    obj.destroy();
    selectNode(null);
  }
}


function deleteNodeById(id) {
  let node = getNodeById(id);
  if (node) {
    deleteNode(node);
  }
}


function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0; // Adjust for SVG's 0-degree being to the right, Konva's Arc often starts from top
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}


function describeArc(x, y, radius, startAngle, endAngle, sweepFlag = 1) {
  // Ensure the arc goes the full circle if the angle is 360
  if (endAngle - startAngle === 360) {
    endAngle = startAngle + 359.99; // A tiny bit less than 360 to ensure an arc, not just a point
  }

  const start = polarToCartesian(x, y, radius, endAngle); // SVG arc draws from current point to end point
  const end = polarToCartesian(x, y, radius, startAngle);

  const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
  // Sweep flag: 1 for clockwise, 0 for counter-clockwise
  // Konva's angle is clockwise by default, so a sweepFlag of 1 often makes sense.
  // If you want text on the "inside" or "outside" of the arc, you'll need to adjust the sweepFlag and potentially the start/end angles.

  const d = [
    "M",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    sweepFlag,
    end.x,
    end.y,
  ].join(" ");

  // M 400 280 A 120 120 0 0 1 520 400 
  //return "M 0 120 c 60 0 60 -80 120 -80 c 60 0 60 80 120 80 c 60 0 60 -80 120 -80 c 60 0 60 80 120 80"
  //console.log("describeArc", d);

  return d;
}

function canResize(node) {
  let canResizeNode = false;

  if (node && node.getClassName && node.getClassName() === "Stage") {
    canResizeNode = true;
    return canResizeNode;
  }

  console.log("selectnode", node.attrs.type, node.attrs?.type.toLowerCase(), node.attrs.group)

  if (node && node.attrs && node.attrs.type) {
    switch (node.attrs?.type.toLowerCase() ?? "unknown") {
      case "baseimage":
        canResizeNode = false;
        break;
      case "text":
        canResizeNode = true;
        break;
      case "textpath":
        canResizeNode = true;
        break;
      case "imageupload":
        canResizeNode = true;
        break;
      case "svgupload":
        canResizeNode = true;
        break;
      case "svgobject":
        if (node.attrs.group === "Tracks") {
          canResizeNode = false;
        } else {
          canResizeNode = true;
        }
        break;
      case "cutout":
        canResizeNode = true;
        break;
      case "beziertextpathgroup":
        canResizeNode = false;
        break;
      case "quadratictextpathgroup":
        canResizeNode = false;
        break;
      case "sinewavetextpath":
        canResizeNode = false;
        break;
      case "circletextpath":
        canResizeNode = false;
        break;
      case "ellipsetextpath":
        canResizeNode = false;
        break;
      case "sidedtextpath":
        canResizeNode = false;
        break;
      case "rectangletextpath":
        canResizeNode = false;
        break;
      case "spiraltextpath":
        canResizeNode = false;
        break;
      case "multipathsvggroup":
        canResizeNode = true;
        break;
    }
  }

  //console.log("canResize", canResizeNode);

  return canResizeNode;
}


function isNodeGrouped(node) {
  return node && node.parent && node.parent.getClassName() === "Group";
}


function selectNode(node, isCtrl = false) {
  //debugger;

  console.log("selectNode", node);
  console.log("isGrouped", isNodeGrouped(node));
  if (node && isNodeGrouped(node)) {
    node = node.parent;
  }

  if (node && node.parent && node.parent.className === "MultiPathSVGGroup") {
    node = node.parent;
  }

  // Don't allow selecting transformer nodes
  if (node && node.getClassName() === "Transformer") {
    console.log("Can't select a transformer node");
    return;
  }

  // Don't allow selecting non-selectable nodes
  if (node && node.attrs && node.attrs.selectable != undefined && node.attrs.selectable === false) {
    console.log("This node is not selectable");
    return;
  }

  if (isCtrl && selectedNode._id != node._id) {
    groupNodes(selectedNode, node);
    return;
  }

  if (selectedNode && selectedNode.setDraggable) {
    selectedNode.setDraggable(false);
  }

  if (selectedNode &&
    (selectedNode.getClassName() === "QuadraticTextPathGroup" ||
      selectedNode.getClassName() === "BezierTextPathGroup")
  ) {
    selectedNode.hideControls();
  }


  if (node && node.getClassName() != "Transformer" && (node.parentNode && node.parentNode.getClassName() != "Transformer") && node.parent != null && node.parent.nodeType === "Group") {
    //node = node.parent;
    console.log("selecting parent node", node, node.parent, node.parent.nodeType, node.parent.getClassName());

    let selParent = node.parent;
    if (selParent.parent.nodeType === "Group" && selParent.parent.getClassName() != "Transformer") {
      //console.log("selecting parent parent node", node.parent);
      selParent = selParent.parent;
    }

    //console.log("selected parent node", selParent);
    node = selParent;
    //selectNode(node.parent);
  }

  //console.log("selectNode", node); 
  if (node && node.attrs && node.attrs.selectable != undefined && node.attrs.selectable === false) {
    //return;
  }

  if (node == getBaseLayer()) {
    return;
  }

  selectedNode = node;
  console.log("selected node", selectedNode, node);
  updateProperties();

  if (node) {
    if (selectedNode &&
      (selectedNode.getClassName() === "QuadraticTextPathGroup" ||
        selectedNode.getClassName() === "BezierTextPathGroup")
    ) {
      selectedNode.showControls();
    }

    selectedNode.setDraggable(true);
    console.log("Adding node to transformer", selectedNode);
    transformer.nodes([selectedNode]);

    //console.log("Updating Node Properties");
    updateProperties();

    let canResizeNode = canResize(node);
    transformer.resizeEnabled(canResizeNode);

    if (canResizeNode === true) {
      //transformer.enabledAnchors(['bottom-right']);
      transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
    } else {
      transformer.enabledAnchors([]);
    }

    //transformer.resizeEnabled(true);
    //transformer.enabledAnchors(['bottom-right']);


  } else {
    transformer.nodes([]);

  }

  return selectedNode;
}


function selectNodeById(id) {
  const findRecursive = (parent) => {
    if (parent._id === id) return parent;
    if (parent.children) {
      for (let child of parent.children) {
        let res = findRecursive(child);
        if (res) return res;
      }
    }
    return null;
  }

  let node = findRecursive(layer);
  if (node) {
    selectNode(node);
  }
}

// Handle selecting nodes
stage.on("click tap", (e) => {
  let isCtrl = e.evt.ctrlKey;
  //console.log("isCtrl", isCtrl, e);

  // if click on empty area or on the transformer itself
  if (
    e.target === stage ||
    e.target === layer ||
    e.target.getParent() === transformer //||
    //(e.target.className === "Image" && e.target.attrs.type === "baseImage")
  ) {
    //transformer.nodes([]);
    layer.draw();
    selectNode(null);
    return;
  }

  //if (e.target.className !== "Image") {
  selectNode(e.target, isCtrl);
  //}
});


/*
layer.on("mouseenter", (e) => {
  console.log("mouseenter", e);
  console.log(JSON.stringify(getBaseLayer().attrs).replaceAll(",", "\r\n"));
});
*/


function textStringUpdated(e) {
  let sel = getSelectedNode();

  if (sel) {
    sel.setText(document.getElementById("textString").value);
    transformer.forceUpdate();

    if (sel.className === "TextPath") {
      console.log("textPath text string changed", sel.fontSize());
      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves));
      } else if (sel.attrs.type === "ellipsetextpath") {
        sel.setData(generateEllipseSvgTextPath(400, 400, 200, 120, 0));
      } else if (sel.attrs.type === "circletextpath") {
        sel.setData(generateCircleSvgTextPath(400, 400, 200));
      }
    }
  }
}

function arcAngleRangeUpdated(e) {
  let sel = getSelectedNode();
  if (sel && sel.className === "TextPath") {
    document.getElementById("arcAngleInput").value =
      document.getElementById("arcAngleRange").value;
    sel.data(
      describeArc(
        400,
        400,
        100,
        document.getElementById("arcAngleRange").value,
        0
      )
    );
    transformer.forceUpdate();
    sel.attrs.angle = parseInt(document.getElementById("arcAngleRange").value);
  }
}

function arcAngleInputUpdated(e) {
  let sel = getSelectedNode();

  if (sel && (sel.className === "Wedge" || sel.className === "Arc")) {
    let angle = parseInt(document.getElementById("arcAngleInput").value);
    sel.setAngle(angle);
  }

  if (sel && sel.className === "TextPath") {
    document.getElementById("arcAngleRange").value = document.getElementById("arcAngleInput").value;
    sel.data(
      describeArc(
        400,
        400,
        100,
        document.getElementById("arcAngleInput").value,
        0
      )
    );
    transformer.forceUpdate();
    sel.attrs.angle = parseInt(document.getElementById("arcAngleInput").value);
  }
}

function fontSizeUpdated(e) {
  let sel = getSelectedNode();
  if (sel) {
    sel.setFontSize(parseInt(document.getElementById("fontSize").value));
    transformer.forceUpdate();

    /*
    if (sel.className === "TextPath") {
      //console.log("textPath font size changed", sel.fontSize());

      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves)) ;
      }
    }
    */
  }
}

function fontStyleUpdated(e) {
  let sel = getSelectedNode();
  if (sel) {
    sel.setFontStyle(document.getElementById("fontStyle").value);
    transformer.forceUpdate();

    /*
    if (sel.className === "TextPath") {
      console.log("textPath font size changed", sel.fontSize());

      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves)) ;
      }
    }
    */
  }
}

function letterSpacingUpdated(e) {
  let sel = getSelectedNode();
  if (sel) {
    sel.setLetterSpacing(parseInt(document.getElementById("letterSpacing").value));
    transformer.forceUpdate();
  }
}


function lineHeightUpdated(e) {
  let sel = getSelectedNode();
  if (sel) {
    sel.lineHeight(parseFloat(document.getElementById("lineHeightInput").value));
    transformer.forceUpdate();
  }
}


function scaleInputUpdated(e) {
  let sel = getSelectedNode();
  if (sel) {
    let scale = parseFloat(
      parseInt(document.getElementById("scaleInput").value) / 100
    );
    sel.scale({ x: scale, y: scale });
    transformer.forceUpdate();
  }
}

function rotationInputUpdated(e) {
  return;

  let sel = getSelectedNode();
  if (sel) {
    let rot = parseInt(document.getElementById("rotationInput").value);
    //sel.setRotation(rot);
    transformer.setRotation(rot);
    transformer.forceUpdate();
  }
}


function convertNegativeDegreesToPositive(degrees) {
  // Use modulo 360 to bring it into the -360 to 360 range
  let normalizedDegrees = degrees % 360;

  // If it's still negative, add 360 to make it positive
  if (normalizedDegrees < 0) {
    normalizedDegrees += 360;
  }
  return normalizedDegrees;
}

async function updateProperties() {
  updateLayers();


  sel = getSelectedNode();

  //console.log("updateProperties", sel.getClassName());
  let propEls = {
    "positionInputs": true,
    "textString": false,
    "align": false,
    "fontStyle": false,
    "fontSize": false,
    "fontFamily": false,
    "letterSpacing": false,
    "lineHeightInput": false,
    "textDirection": false,
    "arcAngleInput": false,
    "scaleInput": false,
    "rotationInput": false,
    "wavesInput": false,
    "waveWidthInput": false,
    "waveHeightInput": false,
    "radiusInput": false,
    "radiusInputX": false,
    "radiusInputY": false,
    "outerRadius": false,
    "innerRadius": false,
    "sidesInput": false,
    "rectangleWidth": false,
    "rectangleHeight": false,
    "rectangleRadius": false,
    "pointsInput": false,
    "width": false,
    "height": false,
    "strokeWidth": false,
    "filledInput": false,
    "pointerWidthInput": false,
    "pointerLengthInput": false,
    "startRadiusInput": false,
    "endRadiusInput": false,
    "revolutionsInput": false,
    "pegSizeSelect": false,
  };

  if (sel) {
    let textString = "";
    let align = "";
    let fontFamily = "";
    let fontStyle = "";
    let fontSize = 0;
    let letterSpacing = 0;
    let lineHeight = 0;
    let angle = 0;
    let direction = "";
    let waves = 1;
    let waveWidth = 1;
    let waveHeight = 1;
    let radius = 0;
    let radiusX = 0;
    let radiusY = 0;
    let outerRadius = 0;
    let innerRadius = 0;
    let sides = 0;
    let points = 0;
    let strokeWidth = 0;
    let filled = false;
    let pointerWidthInput = 0;
    let pointerLengthInput = 0;
    let pegSizeSelect = "";
    let startRadiusInput = 0;
    let endRadiusInput = 0;
    let revolutionsInput = 0;
    let enabledProps = [];
    let propVals = {};


    if (sel.getClassName && sel.getClassName() && (sel.attrs.type === "baseImage")) {
      propEls.positionInputs = false;
    }

    if (sel.getClassName && sel.getClassName() === "Text") {
      enabledProps = [
        "textString",
        "align",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "textDirection",
      ];
    } else if (sel.getClassName && sel.getClassName() && (sel.attrs.type === "sinewavetextpath")) {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "wavesInput",
        "waveWidthInput",
        "waveHeightInput",
      ];
    } else if (sel.getClassName() === "BezierTextPathGroup") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
      ];
    } else if (sel.getClassName() === "QuadraticTextPathGroup") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
      ];
    } else if (sel.getClassName() === "CircleTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInput",
      ];
    } else if (sel.getClassName() === "EllipseTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInputX",
        "radiusInputY",
      ];
    } else if (sel.getClassName() === "RectangleTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "rectangleWidth",
        "rectangleHeight",
        "rectangleRadius",
      ];
    } else if (sel.getClassName() === "SidedTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInput",
        "sidesInput",
      ];
    } else if (sel.getClassName() === "HeartTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
      ];
    } else if (sel.getClassName() === "StarTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
        "radiusInput",
        "pointsInput",
      ];
    } else if (sel.getClassName() === "TeardropTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
      ];
    } else if (sel.getClassName() === "SpiralTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "startRadiusInput",
        "endRadiusInput",
        "revolutionsInput",
      ];
    } else if (sel.getClassName() === "Rect") {
      enabledProps = [
        "width",
        "height",
        "rectangleRadius",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Circle") {
      enabledProps = [
        "radiusInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Ellipse") {
      enabledProps = [
        "radiusInputX",
        "radiusInputY",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Star") {
      enabledProps = [
        "outerRadius",
        "innerRadius",
        "pointsInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Arrow") {
      enabledProps = [
        "strokeWidth",
        "width",
        "pointerWidthInput",
        "pointerLengthInput",
        "filledInput",
      ];
    } else if (sel.getClassName() === "RegularPolygon") {
      enabledProps = [
        "radiusInput",
        "sidesInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Wedge") {
      enabledProps = [
        "radiusInput",
        "arcAngleInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Arc") {
      enabledProps = [
        "arcAngleInput",
        "outerRadius",
        "innerRadius",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "HeartShape") {
      enabledProps = [
        "width",
        "height",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "TeardropShape") {
      enabledProps = [
        "width",
        "height",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Image" && (sel.attrs.group != "Tracks" && sel.attrs.type != "baseImage")) {
      enabledProps = [
        "scaleInput",
        //"rotationInput"       ,
      ];
    } else if (sel.getClassName() === "Track" && (sel.attrs.group == "Tracks")) {
      enabledProps = [
        "pegSizeSelect",
      ];
    }

    enabledProps.forEach((prop) => {
      //console.log("Enable prop", prop);
      propEls[prop] = true;
    });
    //console.log("propEls", propEls);

    Object.entries(propEls).forEach(([key, value]) => {
      //console.log(`${key}: ${value}`);
      try {
        if (!value) {
          document.getElementById(key).setAttribute("disabled", "");
          document.getElementById(key).parentNode.style.display = "none";
        } else {
          document.getElementById(key).removeAttribute("disabled");
          document.getElementById(key).parentNode.style.display = "block";
        }
      }
      catch (e) {
        console.log("Error Caught:", key, value);
        console.error(e);
      }
    });

    Object.entries(propEls).forEach(([key, value]) => {
      propVals[key] = "";
    });


    if (propEls.textString === true) {
      propVals.textString = sel.getText();
      propVals.fontFamily = sel.getFontFamily();
      propVals.fontStyle = sel.getFontStyle();
      propVals.fontSize = sel.getFontSize();
      propVals.letterSpacing = sel.getLetterSpacing();
    }

    if (sel.getClassName() && (sel.attrs.type === "sinewavetextpath")) {
      propVals.wavesInput = sel.waves();
      propVals.waveHeightInput = sel.amplitude();
      propVals.waveWidthInput = sel.frequency();
    }

    if (sel.getClassName() === "Text") {
      propVals.textDirection = sel.attrs.direction;
      propVals.align = sel.getAlign();
    }

    if (sel.getClassName() === "SidedTextPath") {
      propVals.sidesInput = sel.sides();
    }

    if (sel.getClassName() === "RectangleTextPath") {
      propVals.rectangleRadius = sel.rectangleRadius();
    }

    if (sel.getClassName() === "StarTextPath") {
      propVals.pointsInput = sel.points();
      propVals.radiusInput = sel.radius();
    }

    if (sel.getClassName() === "SpiralTextPath") {
      propVals.startRadiusInput = sel.startRadius();
      propVals.endRadiusInput = sel.endRadius();
      propVals.revolutionsInput = sel.revolutions();
    }


    if (sel.getClassName() === "Image") {
      propVals.scaleInput = parseInt(sel.getScaleX() * 100);
      //propVals.rotationInput     = parseInt(sel.getRotation());
    }


    // Shapes
    if (sel.getClassName() === "Rect") {
      propVals.rectangleRadius = sel.getCornerRadius();
      propVals.strokeWidth = sel.getStrokeWidth();
      propVals.filledInput = sel.getFill() != undefined ? true : false;
    }

    if (sel.getClassName() === "Circle") {
      propVals.radiusInput = sel.radius();
      propVals.strokeWidth = sel.getStrokeWidth();
      propVals.filledInput = sel.getFill() != undefined ? true : false;
    }

    if (sel.getClassName() === "Ellipse") {
      propVals.radiusInputX = sel.radiusX();
      propVals.radiusInputY = sel.radiusY();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Star") {
      propVals.pointsInput = sel.getNumPoints();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Arrow") {
      propVals.pointerWidthInput = sel.getPointerWidth();
      propVals.pointerLengthInput = sel.getPointerLength();
    }

    if (sel.getClassName() === "Wedge") {
      propVals.arcAngleInput = sel.getAngle();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Arc") {
      propVals.arcAngleInput = sel.getAngle();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "RegularPolygon") {
      propVals.sidesInput = sel.getSides();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "HeartShape") {
      propVals.width = sel.getWidth();
      propVals.height = sel.getHeight();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "TeardropShape") {
      propVals.width = sel.getWidth();
      propVals.height = sel.getHeight();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Track") {
      propVals.pegSizeSelect = getPegSizeFromScale(sel.scaleX());
    }

    //console.log(propVals);
    Object.entries(propVals).forEach(([key, value]) => {
      if (document.getElementById(key).type != "checkbox") {
        document.getElementById(key).value = value;
      } else {
        document.getElementById(key).checked = value;
      }
    });

  } else {
    Object.entries(propEls).forEach(([key, value]) => {
      try {
        document.getElementById(key).setAttribute("disabled", "");
        document.getElementById(key).parentNode.style.display = "none";
      }
      catch (e) {
        console.log("Error Caught:", key, value);
        console.error(e);
      }
    });
  }

  updateBaseLayerDimensions(baseimagetransformer.size());
}

stage.on("wheel", (e) => {
  e.evt.preventDefault(); // Prevent page scrolling
  let sel = getSelectedNode();

  //console.log(sel);

  if (!sel) {
    //sel = layer;
    sel = stage;
  }

  let canResizeNode = canResize(sel);

  //console.log(canResizeNode);

  if (canResizeNode) {
    if (sel.attrs.type != "text" &&
      sel.attrs.type != "textpath" &&
      sel.attrs.type != "sinewavetextpath" &&
      sel.attrs.type != "beziertextpathgroup" &&
      sel.attrs.type != "quadratictextpathgroup") {
      let scaleObj = null;
      /*
      if (!sel) {
        scaleObj = stage;
      } else if (sel && sel.className == "Image") {
        scaleObj = sel;
      }
      */
      scaleObj = sel;

      const oldScale = scaleObj.scaleX();
      const pointer = stage.getPointerPosition();

      // Calculate pointer position relative to the scaleObj's current viewport
      const mousePointTo = {
        x: (pointer.x - scaleObj.x()) / oldScale,
        y: (pointer.y - scaleObj.y()) / oldScale,
      };

      let newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

      // Optional: Set min/max zoom levels
      const minScale = 0.1;
      const maxScale = 10;
      newScale = Math.max(minScale, Math.min(newScale, maxScale));

      // Calculate new scaleObj position to keep the pointer fixed
      const newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
      };

      scaleObj.scale({ x: newScale, y: newScale });
      scaleObj.position(newPos);
      layer.draw();
      updateBaseLayerDimensions(baseimagetransformer.size());
    } else if (sel.className != "Image") {
      let dir = e.evt.deltaY > 0 ? 1 : -1;
      sel.setFontSize(sel.getFontSize() - dir);
      updateProperties();
    }
  }
});

/*
centerButton.addEventListener('click', () => {
  let sel = getSelectedNode();
  if (sel) {
    centerNodeInBaseImage(sel);
  }
});
*/



// Define a custom Konva filter
Konva.Filters.WhiteToTransparent = function (imageData) {
  const data = imageData.data; // This is a Uint8ClampedArray: [R, G, B, A, R, G, B, A, ...]
  const len = data.length;

  // Define a tolerance for what is considered "white"
  // Pure white is R=255, G=255, B=255
  const tolerance = 10; // Adjust this value (0-255) to be more or less lenient

  for (let i = 0; i < len; i += 4) {
    const r = data[i]; // Red component
    const g = data[i + 1]; // Green component
    const b = data[i + 2]; // Blue component
    // const a = data[i + 3]; // Alpha component (0-255)

    // Check if the pixel is close to white within the defined tolerance
    if (r >= 255 - tolerance && g >= 255 - tolerance && b >= 255 - tolerance) {
      data[i + 3] = 0; // Set alpha to 0 (fully transparent)
    }
  }
};

function removeXmlDeclaration(xmlString) {
  return xmlString.replace(/^<\?xml[^>]*\?>\s*/, "");
}

function arrayBufferToUtf8String(arrayBuffer) {
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(arrayBuffer);
}

//function addSvgImage(svgString, x, y, type, group, width, height) {
function addSvgImage(svgString, x, y, config = {}) {
  //console.log("addSvgImage", x, y, config);


  let svgGroup = new MultiPathSVGGroup({svgString: svgString});

  svgGroup.x(x);
  svgGroup.y(y);

  layer.add(svgGroup);
  layer.batchDraw();
  selectNode(svgGroup); 
  resetTrackIndex();
  return svgGroup;

  /*
  const blackStr = replaceAnyAttributeValue(replaceAnyAttributeValue(svgString, "fill", "#37393B"), "stroke", "#37393B");
  //console.log("addSvgImage", blackStr);
  const base64Svg = removeXmlDeclaration(btoa(unescape(encodeURIComponent(blackStr))));
  const dataUrl = `data:image/svg+xml;base64,${base64Svg}`;



  let svgGroup = new Konva.Group({
    draggable: true, 
    sortable: true,
  });
  svgGroup.className = "multipathsvg";

  const pathRegex = /<path\b([\s\S]*?)(?:\/>|>([\s\S]*?)<\/path>)/g;
  const matchedPaths = blackStr.match(pathRegex);
  console.log("addSvgImage matchedPaths", matchedPaths);

  const dataRegex = /\bd=["']([\s\S]*?)["']/;
  matchedPaths.forEach((path) => {
    let matchResult = path.match(dataRegex);
    console.log("addSvgImage matchResult", matchResult);

    let svgPath = new Konva.Path({
      data: matchResult[1],
      x: 0,
      y: 0,
      fill: "transparent",
      stroke: "#37393B",
      strokeWidth: 1,
      draggable: false,
      sortable: config.group === "Tracks" ? false : true,
    });

    svgGroup.add(svgPath);   
  });

  layer.add(svgGroup);
  layer.batchDraw();
  selectNode(svgGroup); 
  resetTrackIndex();
  return svgGroup;
  */




  /* konva.path method */
  // Match all <path elements
  // <path\b([\s\S]*?)(?:\/>|>([\s\S]*?)<\/path>)
  /*
  const pathRegex = /\bd=["']([\s\S]*?)["']/;

  // Use the match method to find the pattern
  const matchResult = blackStr.match(pathRegex);
  console.log("addSvgImage matchResult", matchResult);

  const pathData = matchResult[1];
  console.log("addSvgImage pathData", pathData);

  let svgPath = new Konva.Path({
    data: pathData,
    x: x,
    y: y,
    fill: "#37393B",
    stroke: "#37393B",
    strokeWidth: 1,
    draggable: true,
    name: config.name ?? "svgobject",
    group: config.group ?? "",
    numberLanes: parseInt(config.numberLanes) ?? 0,
    width: config.width ?? 400,
    height: config.height ?? 400,
    scaleX: config.scaleX ?? 1,
    scaleY: config.scaleY ?? 1,
    sortable: config.group === "Tracks" ? false : true,
  });
  console.log("addSvgImage svgPath", svgPath);
  //svgPath.cache();
  layer.add(svgPath);
  layer.batchDraw();
  selectNode(svgPath);
  resetTrackIndex();
  return;
  */
  

  
  Konva.Image.fromURL(dataUrl, (imageNode) => {
    //console.log("addSvgImage Loaded", imageNode, imageNode.width(), imageNode.height());

    imageNode.x(x);
    imageNode.y(y);
    if (config.width) imageNode.width(config.width);
    if (config.height) imageNode.height(config.height);
    imageNode.draggable(true);

    let addingClickedObject = false;
    if (config.scaleX == undefined) {
      addingClickedObject = true;
    }

    if (config.scale && config.scale != undefined) {
      config.scaleX = config.scale.x;
      config.scaleY = config.scale.y;
    }

    imageNode.setAttrs({
      isFlipped: false,
      type: config.type ?? "svgupload",
      name: config.name ?? "svgupload",
      group: config.group ?? "",
      numberLanes: parseInt(config.numberLanes) ?? 0,
      width: config.width ?? imageNode.width(),
      height: config.height ?? imageNode.height(),
      //scaleX: config.scaleX ?? 1,
      //scaleY: config.scaleY ?? 1,
      scaleX: 1,
      scaleY: 1,
      draggable: false,
      //offsetX: config.offset.x ?? 0,
      //offsetY: config.offset.y ?? 0,
      sortable: config.group === "Tracks" ? false : true,
    });

    //imageNode.setScaleX(config.scaleX);
    //imageNode.setScaleY(config.scaleY);

    if (config.group === "Tracks") {
      //console.log("Loaded Track, setting class name");
      imageNode.className = "Track";
    }

    if (config.type === "cutout") {
      console.log("Loaded cutout");
      imageNode.className = "Cutout";
      imageNode.setAttrs({
        globalCompositeOperation: 'destination-in'
      });
    }

    //console.log("addSvgImage", config, imageNode.getAttrs());

    if (addingClickedObject === true) {
      if (config.group != "Tracks") {
        while (imageNode.getClientRect().width < 200) {
          imageNode.scale({ x: imageNode.scale().x * 1.5, y: imageNode.scale().y * 1.5 });
        }
      }

      imageNode.offset({
        x: imageNode.width() / 2,
        y: imageNode.height() / 2,
      });
    }

    layer.add(imageNode);
    if (config.type === "cutout") {
      imageNode.setZIndex(1);
    }

    if (config.rotation) {
      imageNode.setRotation(config.rotation);
    }

    layer.batchDraw();

    selectNode(imageNode);

    resetTrackIndex();
  });
  

}

function replaceAnyAttributeValue(htmlString, attributeName, newValue) {
  const regex = new RegExp(`${attributeName}\\s?:\\s?#\\s?(.*?)\\s?;`, "gi");

  return htmlString.replace(regex, `${attributeName}:${newValue};`);
}

// Pick Main Board
document.addEventListener("DOMContentLoaded", () => {
  const boardImages = document.querySelectorAll(".boardImage");
  boardImages.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      console.log("boardImage clicked", evt.target);

      if (boardImage) {
        //layer.children[0].destroy();
        boardImage.destroy();
      }

      baseBoard = getBaseBoard(evt.target.dataset.name);
      loadBaseImage(evt.target.dataset.image);
      setBaseBoardConfig(evt.target.dataset);

      //if (getTrack() != null && getCanAddTrack() == false) {
      console.log("baseBoard", baseBoard);
      if (getTrack() != null && baseBoard.can_choose_track === false) {
        destroyTrack();
      }

      document.getElementById("boardsDialog").close();
    });
  });


  // Pick SVG Object
  const svgobjects = document.querySelectorAll(".svgobject");
  svgobjects.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      //console.log("svgobjects clicked", evt.target.dataset.group, getCanAddTrack());
      document.getElementById("svgObjectsDialog").close();
      document.getElementById("tracksDialog").close();

      if (evt.target.dataset.group != "Tracks" || (evt.target.dataset.group == "Tracks" && getCanAddTrack() == true)) {
        console.log("add svg object", evt.target.src, evt.target.dataset);
        let url = new URL(evt.target.src);
        console.log("add svg object url", url);
        console.log("type", getFileExtension(url.pathname));
        let objType = getFileExtension(url.pathname);

        if (objType === "svg") {
          addSVGImageFromURL(evt.target.src, evt.target.dataset);
        } else {
          addTrackImage(url.origin + url.pathname, evt.target.dataset);
        }
      } else {
        showMessage("Notice", "This cribbage board does not allow for custom tracks");
      }
    });
  });


  function getFileExtension(filename) {
    // Split the filename by the dot delimiter
    const parts = filename.split('.');

    // If there's only one part (no dot found) or the filename is just a dot file (e.g., '.gitignore'), return an empty string or handle as needed
    if (parts.length < 2 || parts[0] === '') {
      return '';
    }

    // Get the last element (the extension)
    return parts.pop();
  }


  // Pick SVG Cutout
  const svgcutouts = document.querySelectorAll(".svgcutout");
  svgcutouts.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      //console.log("svgobjects clicked", evt.target.dataset.group, getCanAddTrack());
      document.getElementById("svgCutoutsDialog").close();
      //document.getElementById("tracksDialog").close();

      if (evt.target.dataset.group != "Tracks" || (evt.target.dataset.group == "Tracks" && getCanAddTrack() == true)) {
        let curLayer = getLayerByClassName("Cutout");
        if (curLayer != null) {
          curLayer.destroy();
        }

        addSVGImageFromURL(evt.target.src, evt.target.dataset);
      } else {
        showMessage("Notice", "This cribbage board does not allow for custom tracks");
      }
    });
  });


  function getLayerByClassName(className) {
    return layer.children.find((item) => item.className === className);
  }




  // Pick Design Object
  const designobjects = document.querySelectorAll(".designobject");
  designobjects.forEach((obj) => {
    obj.addEventListener("click", (evt) => {
      //console.log("svgobjects clicked", evt.target.dataset.group, getCanAddTrack());
      document.getElementById("designsDialog").close();

      newDesign();
      loadPrebuiltDesign(evt.target.dataset.title);
    });
  });


});


function loadPrebuiltDesign(title) {
  console.log("loadPrebuiltDesign", title);

  design_files.forEach((obj) => {
    //console.log("loadPrebuiltDesign Checking", obj.title.toLowerCase().trim(), " / ", title.toLowerCase().trim());
    if (obj.title.toLowerCase().trim() == title.toLowerCase().trim()) {
      console.log("loadPrebuiltDesign Loading", obj);
      //layerFromJSON(JSON.parse(obj.design_data));


      //console.log("layerFromJSON", json);

      selectNode(null);
      newDesign();
      /*
      let items = layer.getChildren();
      items.forEach((item) => {
        if (item.className !== "Transformer") {
          item.destroy();
        }
      });
      */

      let json = JSON.parse(obj.design_data);
      layerFromJSON(json);
      return;


      let children = json.children;
      children.forEach((item) => {
        //console.log("layerFromJSON Add Item", item);
        //console.log(item);
        //console.log(item.className);
        //console.log(item.attrs);

        if (item.className === "Image" && item.attrs.type == "baseImage") {
          loadBaseImage(item.attrs.name);
          console.log("load base layer");
        } else if (item.className === "Image" && item.attrs.type == "svgobject") {
          doGetSvgFromUrl(item.attrs.name, item.attrs);
          console.log("load svg object");

        } else if (item.className === "Text") {
          //createTextNode(item.attrs);

        } else if (item.className === "TextPath") {
          //createTextPathNode(item.attrs);

        }
      });

      setTimeout(function () {
        children.forEach((item) => {
          if (item.className === "Text") {
            createTextNode(item.attrs);
            console.log("load text");

          } else if (item.className === "TextPath") {
            createTextPathNode(item.attrs);
            console.log("load text path");

          }
        });
      }, 3000);

    }
  });
}


function addSVGImageFromURL(svgUrl, dataset) {
  console.log("addSVGImageFromURL", svgUrl, dataset);

  Konva.Image.fromURL(
    svgUrl,
    function (imageNode) {
      if (dataset.group == "Tracks" && getCanAddTrack() == false) {
        return;
      }

      if (dataset.group == "Tracks" && getTrack() != null) {
        destroyTrack();
      }

      doGetSvgFromUrl(svgUrl, {
        width: imageNode.width() * (72 / 96),
        height: imageNode.height() * (72 / 96),
        draggable: false,
        isFlipped: false,
        name: svgUrl,
        //scale: {x: getBaseLayerScale(), y: getBaseLayerScale()},
        //type: 'svgobject',
        type: dataset.type,
        group: dataset.group,
        numberLanes: dataset.lanes,
        sortable: dataset.group === "Tracks" ? false : true,
      });
    },
    (error) => {
      console.error("Error loading SVG:", error);
    }
  );
}

// Add handler for accordion headers
document.addEventListener("DOMContentLoaded", () => {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      // Get the parent accordion item
      const accordionItem = header.closest(".accordion-item");
      if (!accordionItem) return; // Should not happen if HTML is correct

      const accordionContent =
        accordionItem.querySelector(".accordion-content");
      const accordionIcon = header.querySelector(".accordion-icon");

      // Toggle the 'active' class on the header
      header.classList.toggle("active");

      // Toggle the 'show' class on the content
      if (accordionContent.classList.contains("show")) {
        // If it's currently shown, hide it
        accordionContent.classList.remove("show");
        // Set max-height to 0 to trigger the CSS transition
        //accordionContent.style.maxHeight = null; // Reset to allow transition
      } else {
        // If it's hidden, show it
        accordionContent.classList.add("show");
        // Set max-height to its scrollHeight to enable smooth transition
        // This value needs to be large enough to contain all content.
        // Using scrollHeight is the most precise way for autoLoadDesign === true-height transitions. {
        //accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }

      // Optional: Close other open accordion items (uncomment if desired)
      accordionHeaders.forEach((otherHeader) => {
        const otherAccordionItem = otherHeader.closest(".accordion-item");
        if (otherAccordionItem !== accordionItem) {
          otherHeader.classList.remove("active");
          const otherContent = otherAccordionItem.querySelector(".accordion-content");
          otherContent.classList.remove("show");
          otherContent.style.maxHeight = null;
        }
      });
    });
  });
});

function getBoard() {
  let baseLayer = getBaseLayer();
  let ret = null;

  if (baseLayer) {
    board = customizer_boards.forEach((board) => {
      if (board.board_image === baseLayer.attrs.name) {
        ret = board;
      }
    });
  }

  return ret;
}

function getBaseLayer() {
  var matched = layer.getChildren(function (node) {
    return node.getClassName() === "Image" && node.attrs.type === "baseImage";
    //return node.getClassName() === "BaseLayer";
  });

  if (matched && matched.length) {
    matched = matched[0];
  } else {
    matched = null;
  }

  return matched;
}

function getTrack() {
  var matched = layer.getChildren(function (node) {
    return node.attrs.type === "svgobject" && node.attrs.group === "Tracks";
    //return node.getClassName() === "Track";
  });

  if (matched && matched.length) {
    matched = matched[0];
  } else {
    matched = null;
  }

  return matched;
}


function resetTrackIndex() {
  let track = getTrack();
  if (track) {
    track.setZIndex(1);
  }
}


function moveTrackLayer() {
  return;

  let track = getTrack();

  if (track) {
    track.moveToBottom();
    track.moveUp();
  }
}


function getBaseLayerScale() {
  let scale = 1.0;

  if (getBaseLayer())
    scale = getBaseLayer().getScale().x;

  return scale;
}


function flipHorizontal(obj) {
  if (obj && obj.attrs.group != "Tracks") {
    obj.setScaleX(-obj.getScaleX())
  }
}

function flipVertical(obj) {
  if (obj && obj.attrs.group != "Tracks") {
    obj.setScaleY(-obj.getScaleY())
  }
}

function centerNodeInBaseImage(obj) {
  if (getSelectedNode()) {
    //const parentRect = getBaseLayer().getClientRect();
    const parentPos = getBaseLayer().getAbsolutePosition();
    const parentSize = getBaseLayer().getSize();
    const objRect = getSelectedNode().getClientRect();
    const pos = {
      x: (parentPos.x + (parentSize.width / 2)),
      y: (parentPos.y + (parentSize.height / 2)),
    };

    getSelectedNode().position(pos);

    layer.batchDraw(); // Use batchDraw for efficiency
  }
}


function centerNodeOffset(node) {
  if (node) {
    node.offset({
      x: node.width() / 2,
      y: node.height() / 2,
    });
  }
}


async function getSvgStringFromUrl(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const svgString = await response.text();
    return svgString;
  } catch (error) {
    console.error("Error fetching SVG:", error);
    return null;
  }
}

function doGetSvgFromUrl(svgUrl, config) {
  //console.log("doGetSvgFromUrl get", svgUrl, config);

  getSvgStringFromUrl(svgUrl).then((svgString) => {
    if (svgString) {
      //console.log("doGetSvgFromUrl gotSvg", svgString);
      addSvgImage(svgString, config.x ?? 60 + getBaseLayer().width() / 2, config.y ?? 60 + getBaseLayer().height() / 2, config);
    }
  });
}

// handel interacting with panels
document.addEventListener("DOMContentLoaded", () => {
  /*
  const toggleButton = document.getElementById("toggleButton");
  const dockedPanel = document.getElementById("docked-panel");

  // State variable to track if the user has explicitly expanded/collapsed the panel
  // This helps manage media query behavior
  let userHasInteracted = false;

  toggleButton.addEventListener("click", () => {
    dockedPanel.classList.toggle("collapsed");
    userHasInteracted = true; // User has interacted, override media query
    if (dockedPanel.classList.contains("collapsed")) {
      dockedPanel.classList.remove("user-expanded");
    } else {
      dockedPanel.classList.add("user-expanded");
    }
  });
  */

  // Handle media query for automatic panel collapse on smaller screens
  /*
  const mediaQuery = window.matchMedia("(max-width: 768px)");

  function handleMediaQueryChange(e) {
    if (e.matches) {
      // Screen is 768px or less
      if (
        !userHasInteracted ||
        !dockedPanel.classList.contains("user-expanded")
      ) {
        dockedPanel.classList.add("collapsed");
      }
    } else {
      // Screen is wider than 768px
      // If user hasn't interacted or if it was collapsed by media query, expand it
      if (!userHasInteracted || !dockedPanel.classList.contains("collapsed")) {
        dockedPanel.classList.remove("collapsed");
      }
      // Ensure user-expanded class is only present if explicitly opened by user
      if (!dockedPanel.classList.contains("collapsed")) {
        dockedPanel.classList.add("user-expanded");
      } else {
        dockedPanel.classList.remove("user-expanded");
      }
    }
  }

  // Initial check
  handleMediaQueryChange(mediaQuery);

  // Listen for changes
  mediaQuery.addListener(handleMediaQueryChange);
  */
});


function getSelectedIndex() {
  let ret = null
  if (selectedNode) {
    ret = selectedNode.index;
  }
  return ret;
}


function getFirstObjectIndex() {
  let items = layer.getChildren();
  let ret = null;
  let pos = 0;

  items.forEach((item) => {
    if (item.attrs.type != "baseImage" && item.className != "Transformer") {
      if (ret == null) {
        ret = pos;
      }
    }
    pos++;
  });

  return ret;
}


nextButton.addEventListener("click", (event) => {
  selectNextObject();
});

function selectNextObject() {
  let idx = getSelectedIndex();
  let toSel = 0;

  if (idx == null) {
    toSel = getFirstObjectIndex();
  } else {
    idx++;

    if (idx + 1 > layer.children.length) {
      toSel = getFirstObjectIndex();
    } else {
      toSel = idx;
    }
  }

  selectNode(layer.children[toSel]);
}







// Responsive Handling
/*
// Function to make the stage responsive
function fitStageIntoParentContainer() {
  // Get the container element
  const container = document.getElementById('container');
  
  // Make the container take up the full width
  container.style.width = '100%';
  
  // Get current container width
  const containerWidth = container.offsetWidth;
  
  // Calculate scale based on virtual width vs actual width
  const scale = containerWidth / sceneWidth;
  
  // Set stage dimensions and scale
  stage.width(sceneWidth * scale);
  stage.height(sceneHeight * scale);
  stage.scale({ x: scale, y: scale });





  // Get stage and image dimensions
  const stageWidth = stage.width();
  const stageHeight = stage.height();
  const imageWidth = getBaseLayer().image().width;
  const imageHeight = getBaseLayer().image().height;

  // Calculate scale factors
  const scaleX = stageWidth / imageWidth;
  const scaleY = stageHeight / imageHeight;

  // Determine the correct scale (contain)
  const newscale = Math.min(scaleX, scaleY) * 0.9;
  //console.log("Base Image Scale: ", scale);

  // Apply scale to the image
  getBaseLayer().scale({ x: newscale, y: newscale });





  console.log("fitStageIntoParentContainer", sceneWidth, sceneHeight, scale);
}

// Initial fit
document.addEventListener("DOMContentLoaded", () => {
  fitStageIntoParentContainer();
});

// Adapt the stage on window resize
window.addEventListener('resize', fitStageIntoParentContainer);
*/



function getParamsFromUrl(url) {
  url = url.replaceAll("+", "%20");
  url = decodeURIComponent(url);

  if (typeof url === 'string') {
    let params = url.split('?');
    let eachParamsArr = params[1].split('&');
    let obj = {};
    if (eachParamsArr && eachParamsArr.length) {
      eachParamsArr.map(param => {
        let keyValuePair = param.split('=')
        let key = keyValuePair[0];
        let value = keyValuePair[1];
        obj[key] = value;
      })
    }
    return obj;
  }
}


function handleDropFileUpload(files) {
  console.log("handleDropFileUpload", files);

  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append('files[]', files[i]); // Append each file
  }

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    console.log("Processing file:", file.name, file.type, file.size);

    // Check if the file type is an image
    if (
      file.type !== "image/jpeg" &&
      file.type !== "image/png" &&
      file.type !== "image/webp" &&
      file.type !== "image/svg+xml"
    ) {
      console.error("not a valid file image type");
      return;
    }

    const reader = new FileReader();

    // What to do when the file is successfully read
    reader.onload = (e) => {
      const fileContents = e.target.result;

      if (file.type === "image/svg+xml") {
        //img = fileContents;
        addSvgImage(arrayBufferToUtf8String(fileContents), 60 + getBaseLayer().width() / 2, 60 + getBaseLayer().height() / 2);
        return;
      }

      const blob = new Blob([fileContents], { type: file.type });
      const imageUrl = URL.createObjectURL(blob);
      let img = new Image();

      img.onload = () => {
        let loadedImage = null;

        // 5. Create Konva.Image after HTMLImageElement is loaded
        loadedImage = new Konva.Image({
          x: 60 + getBaseLayer().width() / 2,
          y: 60 + getBaseLayer().height() / 2,
          image: img,
          width: img.width, // Use original image dimensions
          height: img.height,
          draggable: false,
          name: "uploadedImage",
          type: "imageupload",
        });

        // Optional: Scale down if image is too large for the stage
        const maxDimension = Math.max(img.width, img.height);
        const stageMax = Math.min(stage.width(), stage.height());
        if (maxDimension > stageMax * 0.8) {
          // If image is larger than 80% of stage
          const scale = (stageMax * 0.8) / maxDimension;
          loadedImage.width(img.width * scale);
          loadedImage.height(img.height * scale);
        }

        loadedImage.offset({
          x: loadedImage.width() / 2,
          y: loadedImage.height() / 2,
        });

        layer.add(loadedImage);
        loadedImage.filters([
          Konva.Filters.Grayscale,
          Konva.Filters.WhiteToTransparent,
        ]);
        loadedImage.cache();
        layer.draw();

        //layer.children[layer.children.length-1].moveToBottom();
        //layer.children[0].moveUp();

        selectNode(loadedImage);

        // IMPORTANT: Revoke the Object URL to release memory when the image is no longer needed
        // or when the page is unloaded. For this example, we'll revoke it immediately
        // as the HTMLImageElement has now loaded the data. If you needed the URL
        // for other purposes, you might revoke it later.
        URL.revokeObjectURL(imageUrl);
      };

      img.onerror = () => {
        statusDiv.textContent = "Error loading image from URL.";
        statusDiv.classList.add("error");
        URL.revokeObjectURL(imageUrl); // Revoke even on error
      };

      img.src = imageUrl; // Set the image source

      document.getElementById("imageFileInput").value = "";
    };

    // What to do if an error occurs during reading
    reader.onerror = (e) => {
      console.error("FileReader error:", reader.error);
    };

    // Read the file as binary
    reader.readAsArrayBuffer(file);
  }





  /*
  // Example using fetch for upload
  fetch('/upload-endpoint', {
      method: 'POST',
      body: formData,
  })
  .then(response => response.json())
  .then(data => {
      console.log('Upload successful:', data);
      // Update UI with success message
  })
  .catch(error => {
      console.error('Upload failed:', error);
      // Update UI with error message
  });
  */

  // For progress tracking, XMLHttpRequest might be preferred
  // const xhr = new XMLHttpRequest();
  // xhr.open('POST', '/upload-endpoint');
  // xhr.upload.addEventListener('progress', (e) => {
  //     if (e.lengthComputable) {
  //         const percent = (e.loaded / e.total) * 100;
  //         console.log(`Upload progress: ${percent.toFixed(2)}%`);
  //     }
  // });
  // xhr.onload = () => { /* handle response */ };
  // xhr.onerror = () => { /* handle error */ };
  // xhr.send(formData);  
}


function initDropZone() {
  //dropZone = document.getElementById("app-container");
  dropZone = document.querySelector(".main-content");

  dropZone.addEventListener('dragover', (e) => {
    e.preventDefault(); // Prevent default opening of dropped files
    e.stopPropagation(); // Stop event propagation
    e.dataTransfer.dropEffect = 'copy'; // Visual cue for copying
  });

  dropZone.addEventListener('dragleave', (e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  dropZone.addEventListener('drop', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = e.dataTransfer.files; // FileList object of dropped files

    if (files.length > 0) {
      // Process the files, e.g., upload them
      handleDropFileUpload(files);
    }
  });
}


document.addEventListener("DOMContentLoaded", () => {
  initApp();
});


async function initApp() {


  // Show Help Dialog
  if (localStorage.getItem('hasViewedHelp') != 'true') {
    localStorage.setItem('hasViewedHelp', 'true');
    document.getElementById("helpDialog").showModal();
  }

  // Move request form to dialog
  /*
  setTimeout(function() {
    if (document.getElementById('shopify-section-template--24727777804573__1749919003b4b3c36c')) {
      const parentDiv = document.querySelector('#quoteFormDialog .dialog-content');
      const newDiv = document.getElementById('shopify-section-template--24727777804573__1749919003b4b3c36c');
      parentDiv.appendChild(newDiv);
    }
  }, 3000);  
  */

  // Close Dialogs
  document.querySelectorAll(".closeDialog").forEach((btn) => {
    btn.addEventListener("click", (evt) => {
      btn.parentNode.parentNode.close();
    });
  });


  initButtons();
  loadStains();


  const designDocument = document;
  designDocument.addEventListener('keydown', handleKeyPress);


  setTimeout(function () {
    if (document.getElementById('shopify-section-template--24727777804573__1749919003b4b3c36c')) {
      const newDiv = document.getElementById('shopify-section-template--24727777804573__1749919003b4b3c36c').style('display', 'none');
    }
  }, 3000);


  initDropZone();


  //loadPrebuiltDesign('Game Night');

  //loadPrebuiltDesign('TV Tray With Standard Track');
  //loadBaseImage("customizer-tv-tray-light_523c3081-106d-4246-acfc-e482f16fe825.webp");

  //loadBaseImage("customizer-tv-tray-blank-light.webp");
  //setTimeout(function() {
  //  document.querySelector(".svgobject[title='Standard - 2 Lanes']").click();
  //}, 1000);  



  if (window.location.search && window.location.search.trim() != '') {
    let urlParams = getParamsFromUrl(window.location.search);

    if (urlParams && urlParams.design != undefined) {
      console.log("Loading Design", urlParams.design);
      loadPrebuiltDesign(urlParams.design);

    } else if (urlParams && urlParams.board != undefined) {
      loadBaseBoard(urlParams.board);

    }
  } else if (autoLoadDesign === true) {
    document.querySelector(".boardImage[title='Baltic Birch Plywood - 15x15 Square']").click();
    //loadPrebuiltDesign('TV Tray With Standard Track');
    //await loadBaseBoard('Baltic Birch Plywood - 15x15 Square');
    //await new Promise(r => setTimeout(updateProperties, 500));
  }


  //loadBaseImage("baltic_birch_-_15x15_2e9ef34d-edc6-4be6-8ef9-0674e445fd59.jpg");


  let menucommands = document.querySelectorAll(".dropdownmenu-menu a");
  menucommands.forEach(mc => {
    mc.addEventListener("click", (event) => {
      let menucon = document.querySelector(".dropdownmenu-container.show");
      if (menucon) {
        menucon.classList.remove("show");
      }
    });
  })

  let menucommands2 = document.querySelectorAll(".dropdownmenu-menu span");
  menucommands2.forEach(mc => {
    mc.addEventListener("click", (event) => {
      let menucon = document.querySelector(".dropdownmenu-container.show");
      if (menucon) {
        menucon.classList.remove("show");
      }
    });
  })


  //handleWindowResize();


}




function ctxCenter() {
  //console.log("ctxCenter");
  closeContentMenu();
}
function ctxDuplicate() {
  //console.log("ctxDuplicate");
  closeContentMenu();
}
function ctxFlipVertical() {
  //console.log("ctxFlipVertical");
  closeContentMenu();
  flipVertical(getSelectedNode());
}
function ctxFlipHorizontal() {
  //console.log("ctxFlipHorizontal");
  closeContentMenu();
  flipHorizontal(getSelectedNode());
}
function ctxRotateLeft() {
  //console.log("ctxRotateLeft");
  closeContentMenu();
  rotateObject(getSelectedNode(), -45);
}
function ctxRotateRight() {
  //console.log("ctxRotateRight");
  closeContentMenu();
  rotateObject(getSelectedNode(), 45);
}
function ctxIncreaseSize() {
  //console.log("ctxIncreaseSize");
  closeContentMenu();
  scaleObject(getSelectedNode(), 0.1);
}
function ctxDecreaseSize() {
  //console.log("ctxDecreaseSize");
  closeContentMenu();
  scaleObject(getSelectedNode(), -0.1);
}
function ctxDelete() {
  //console.log("ctxDelete");
  closeContentMenu();
  handleDeleteItem();
}

function ctxMoveNodeDown() {
  closeContentMenu();
  moveSelectedNodeDown();
}

function ctxMoveNodeUp() {
  closeContentMenu();
  moveSelectedNodeUp();
}




// Create a div to use as a context menu
const menuNode = document.createElement('div');
menuNode.id = 'contextMenu';
menuNode.style.position = 'fixed';
menuNode.classList.add("contextMenu");


// Create buttons for the menu
const closeButton = document.createElement('button');
closeButton.innerHTML = '<i class="material-icons-round">cancel</i>';
closeButton.classList.add("contextMenuItem");
closeButton.classList.add("right");
closeButton.onclick = closeContentMenu;




menuNode.appendChild(closeButton);

contextMenuItems.forEach(mi => {
  let ctxButton = document.createElement('button');
  ctxButton.innerHTML = '<i class="material-icons-round">' + mi.icon + '</i>';
  ctxButton.classList.add("contextMenuItem");
  if (mi.class) {
    ctxButton.classList.add(mi.class);
  }
  ctxButton.title = mi.title;
  ctxButton.onclick = mi.action;

  menuNode.appendChild(ctxButton);
});


// Add buttons to menu
document.body.appendChild(menuNode);

// Hide menu on document click
window.addEventListener('click', () => {
  //console.log('window clicked closeContentMenu');
  //closeContentMenu();
});

function closeContentMenu() {
  menuNode.style.display = 'none';
}

// Add context menu event
stage.on('contextmenu', function (e) {
  // prevent default behavior
  e.evt.preventDefault();
  if (e.target === stage) {
    // if we are on empty place of the stage we will do nothing
    return;
  }
  //currentShape = e.target;
  selectNode(e.target);

  // show menu
  menuNode.style.display = 'initial';
  const containerRect = stage.container().getBoundingClientRect();
  menuNode.style.top = containerRect.top + stage.getPointerPosition().y + 4 + 'px';
  menuNode.style.left = containerRect.left + stage.getPointerPosition().x + 4 + 'px';
});

/*
window.addEventListener('mousedown', (e) => {
    pressTimer = setTimeout((evt) => {
        e.preventDefault();
        e.stopPropagation();

        // This code executes if it's a long press
        console.log('Long press detected!', startMousePos, endMousePos);
        // Perform long press action here
        //console.log(e.target);
        //selectNode(e.target);

        //currentShape = e.target;
        // show menu
        menuNode.style.display = 'initial';
        const containerRect = stage.container().getBoundingClientRect();
        menuNode.style.top = containerRect.top + stage.getPointerPosition().y + 4 + 'px';
        menuNode.style.left = containerRect.left + stage.getPointerPosition().x + 4 + 'px';

    }, longPressDelay);
});


window.addEventListener('mouseup', (e) => {
    clearTimeout(pressTimer); // Clear the timer if it's a regular click
});

window.addEventListener('mouseleave', (e) => {
    clearTimeout(pressTimer); // Also clear if the mouse leaves the element while pressed
});
*/

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeContentMenu();
  } else if (selectedNode && document.activeElement.tagName.toLowerCase() !== 'input' && document.activeElement.tagName.toLowerCase() !== 'textarea') {
    const step = event.shiftKey ? 10 : 1;
    let change = false;

    if (event.key === "ArrowLeft") {
      selectedNode.x(selectedNode.x() - step);
      change = true;
    } else if (event.key === "ArrowRight") {
      selectedNode.x(selectedNode.x() + step);
      change = true;
    } else if (event.key === "ArrowUp") {
      selectedNode.y(selectedNode.y() - step);
      change = true;
    } else if (event.key === "ArrowDown") {
      selectedNode.y(selectedNode.y() + step);
      change = true;
    }

    if (change) {
      event.preventDefault();
      layer.batchDraw();
      updateProperties();
    }
  }
});









function initButtons() {
  // 1st drop down menu ( File )
  document.getElementById("file_new").addEventListener("click", (event) => {
    //if (layer.getChildren().length > 2 && confirm("Start a New Degisn ?")) {
    if (confirm("Start a New Degisn ?")) {
      newDesign();
    }
  });

  document.getElementById("file_save").addEventListener("click", () => {
    fileSaveDesign();
  });

  document.getElementById("file_download").addEventListener("click", () => {
    downloadDesign();
  });

  document.getElementById("downloadSavedDesign").addEventListener("click", () => {
    fileDownloadDesign();
  });

  document.getElementById("file_load").addEventListener("click", () => {
    fileLoadDesign();
  });

  document.getElementById("loadSavedDesign").addEventListener("click", () => {
    fileLoadSavedDesign();
  });

  document.getElementById("selectSavedDesign").addEventListener("change", () => {
    selectSaveDesign();
  });

  document.getElementById("deleteSavedDesign").addEventListener("click", () => {
    fileDeleteSavedDesign();
  });

  document.addEventListener("DOMContentLoaded", () => {
    fileProcessUploadedJsonFile();
  });

  document.getElementById("file_capture").addEventListener("click", function () {
    saveDesignAsImage();
  });

  document.getElementById("file_designs").addEventListener("click", function () {
    document.getElementById("designsDialog").showModal();
  });




  // 2nd drop down menu ( Images )
  document.getElementById("select_board").addEventListener("click", function () {
    document.getElementById("boardsDialog").showModal();
  });

  document.getElementById("select_track").addEventListener("click", function () {
    openSelectTrackDialog()
  });

  document.getElementById("upload_image").addEventListener("click", () => {
    document.getElementById("imageFileInput").click();
  });

  document.getElementById("select_object").addEventListener("click", () => {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a board first");
    } else {
      document.getElementById("svgObjectsDialog").showModal();
    }
  });

  document.getElementById("select_cutout").addEventListener("click", () => {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a board first");
    } else {
      document.getElementById("svgCutoutsDialog").showModal();
    }
  });

  document.getElementById("add_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createTextNode({});
  });

  document.getElementById("add_curved_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createTextPathNode({});
  });

  document.getElementById("add_quadratic_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createQuadraticTextPathGroupNodde();
  });

  document.getElementById("add_bezier_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createBezierTextPathGroupNodde();
  });

  document.getElementById("add_sinewave_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createSinewaveTextPathNode();
  });

  document.getElementById("add_circle_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createCircleTextPathNode();
  });

  document.getElementById("add_ellipse_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createEllipseTextPathNode();
  });

  document.getElementById("add_rectangle_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createRectangleTextPathNode();
  });

  document.getElementById("add_sided_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createSidedTextPathNode();
  });

  document.getElementById("add_heart_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createHeartTextPathNode();
  });

  document.getElementById("add_star_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createStarTextPathNode();
  });

  document.getElementById("add_teardrop_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createTeardropTextPathNode();
  });

  document.getElementById("add_spiral_text").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    createSpiralTextPathNode();
  });




  document.getElementById("add_shape_rectangle").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeRectangle();
  });

  document.getElementById("add_shape_circle").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeCircle();
  });

  document.getElementById("add_shape_ellipse").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeEllipse();
  });

  document.getElementById("add_shape_star").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeStar();
  });

  document.getElementById("add_shape_arrow").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeArrow();
  });

  document.getElementById("add_shape_multisided").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeMultiSided();
  });

  document.getElementById("add_shape_wedge").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeWedge();
  });

  document.getElementById("add_shape_arc").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeArc();
  });

  document.getElementById("add_shape_heart").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeHeart();
  });

  document.getElementById("add_shape_teardrop").addEventListener("click", function () {
    if (!getBaseLayer()) {
      showMessage("Notice", "You must select a Cribbage board first");
      return;
    }
    addShapeTeardrop();
  });




  // 3rd drop down menu (Text)
  document.getElementById("edit_duplicate").addEventListener("click", function () {
    duplicateNode();
  });

  document.getElementById("edit_delete").addEventListener("click", function () {
    handleDeleteItem();
  });

  document.getElementById("edit_ungroup").addEventListener("click", function () {
    if (selectedNode) {
      ungroupNode(selectedNode);
    }
  });




  // 4th drop down menu ( Edit )
  document.getElementById('align_center').addEventListener('click', function (event) {
    centerNodeInBaseImage();
  });

  document.getElementById('edit_flip_horizontal').addEventListener('click', function (event) {
    flipHorizontal(getSelectedNode());
  });

  document.getElementById('edit_flip_vertical').addEventListener('click', function (event) {
    flipVertical(getSelectedNode());
  });

  document.getElementById('edit_move_down').addEventListener('click', function (event) {
    if (selectedNode) {
      moveSelectedNodeDown();
    }
  });

  document.getElementById('edit_move_up').addEventListener('click', function (event) {
    if (selectedNode) {
      moveSelectedNodeUp();
    }
  });

  document.getElementById('edit_layers').addEventListener('click', function (event) {
    if (getSortableNodes().length > 1) {
      editLayers();
    } else {
      showMessage("Notice", "You must add some Text, Shapes or Images first");
    }
  });




  // 5th drop down menu ( About )
  document.getElementById("about_help").addEventListener('click', (event) => {
    document.getElementById("helpDialog").showModal();
  });


  document.getElementById("about_quote").addEventListener('click', (event) => {
    document.getElementById("quoteFormDialog").showModal();
  });

}


// For Down Down Menus
document.addEventListener('DOMContentLoaded', function () {
  const dropdownToggles = document.querySelectorAll('.dropdownmenu-toggle');

  dropdownToggles.forEach((dropdownToggle) => {
    const dropdownContainer = dropdownToggle.parentNode;

    dropdownToggle.addEventListener('click', function () {
      // Toggle the 'show' class on the container to display/hide the menu
      dropdownContainer.classList.toggle('show');
      // Toggle 'active' class on the button to rotate the arrow
      dropdownToggle.classList.toggle('active');

      // Update aria-expanded attribute for accessibility
      const isExpanded = dropdownToggle.getAttribute('aria-expanded') === 'true';
      dropdownToggle.setAttribute('aria-expanded', !isExpanded);
    });

    // Close the dropdown if the user clicks outside of it
    document.addEventListener('click', function (event) {
      if (!dropdownContainer.contains(event.target)) {
        dropdownContainer.classList.remove('show');
        dropdownToggle.classList.remove('active');
        dropdownToggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
});






function getAllLocalStorageKeys() {
  const keys = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    keys.push(key);
  }

  return keys;
}

function getLocalStorageDesigns() {
  const keys = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.includes(designNamePrefix)) {
      keys.push(key);
    }
  }

  return keys;
}

function saveDesign(name, data) {
  localStorage.setItem(name, data);
}

function loadDesign(name) {
  deleteAllObjects();
  layerFromJSON(localDesignToJSON(localStorage.getItem(name)));
}

function loadDesignJSON(name) {
  return localDesignToJSON(localStorage.getItem(name));
}

function doesDesignExist(name) {
  return localStorage.getItem(name) != null;
}

function getLocalDesignThumbnail(name) {
  let designJson = localDesignToJSON(localStorage.getItem(name));
  return designJson.image;
}


//const allKeys = getAllLocalStorageKeys();
//console.log(allKeys);

function localDesignToJSON(data) {
  const dataURI = decodeURIComponent(data);

  //const dataURI = "data:application/json;base64,ew0KICAgICJtYWx0X3R5cGUiOiAibG9nIiwNCiAgICAibWFsdF9kYXRhIjogIldvdywgdSByIGFsbW9zdCB0aGVyZSA6TyINCn0=";

  // 1. Extract the Base64 encoded data
  //const base64Data = dataURI.split(',')[1];
  const base64Data = dataURI.replace("data:text/json;charset=utf-8,", "");
  //console.log("base64Data");
  //console.log(base64Data);

  // 2. Decode the Base64 data
  //const decodedString = atob(base64Data); // 'atob' decodes Base64

  // 3. Parse the JSON string
  try {
    const jsonObject = JSON.parse(base64Data);
    //console.log(jsonObject);
    return jsonObject;
  } catch (error) {
    console.error("Error parsing JSON:", error);
  }

}


function saveCurrentDesign() {
  let layerJson = layer.toJSON();
  var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(layerJson);
  saveDesign("currentcustomizerdesign", dataStr);
}



function resizeImageDataURI(dataURI, newWidth, newHeight, format = 'image/jpeg', quality = 1.0) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      const resizedDataURI = canvas.toDataURL(format, quality);
      resolve(resizedDataURI);
    };
    img.src = dataURI;
  });
}

function createDesignThumbnail() {
  selectNode(null);

  return new Promise(function (resolve, reject) {
    const originalDataURI = trimCanvas().toDataURL({ pixelRatio: 2 });
    //console.log("originalDataURI");
    //console.log(originalDataURI);

    var memoryImg = document.createElement('img');
    memoryImg.src = originalDataURI;
    let resizedDataURI = "";

    memoryImg.onload = function () {
      //console.log("memoryImg Loaded");

      var width = memoryImg.width;
      var height = memoryImg.height;
      //console.log("getImageDataURIDimensions", {"width": width, "height": height});

      let originalWidth = width;
      let originalHeight = height;

      let maxWidth = 200; // Example: desired maximum width
      let newWidth = originalWidth;
      let newHeight = originalHeight;

      //console.log("originalWidth, maxWidth", originalWidth, maxWidth);
      // If the image is wider than the max width
      if (originalWidth > maxWidth) {
        newWidth = maxWidth;
        newHeight = (originalHeight * maxWidth) / originalWidth;
      }
      //console.log("newWidth, newHeight", newWidth, newHeight);

      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(memoryImg, 0, 0, newWidth, newHeight);
      resizedDataURI = canvas.toDataURL('image/png', 100);

      //return resizedDataURI;
    };

    resolve(resizedDataURI);
  });

}




function createDesignThumbnailWorking() {
  selectNode(null);



  const originalDataURI = trimCanvas().toDataURL({ pixelRatio: 2 });

  var memoryImg = document.createElement('img');
  memoryImg.src = originalDataURI;

  memoryImg.onload = function () {
    var width = memoryImg.width;
    var height = memoryImg.height;
    //console.log("getImageDataURIDimensions", {"width": width, "height": height});

    let originalWidth = width;
    let originalHeight = height;

    let maxWidth = 200; // Example: desired maximum width
    let newWidth = originalWidth;
    let newHeight = originalHeight;

    //console.log("originalWidth, maxWidth", originalWidth, maxWidth);
    // If the image is wider than the max width
    if (originalWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = (originalHeight * maxWidth) / originalWidth;
    }
    //console.log("newWidth, newHeight", newWidth, newHeight);

    resizeImageDataURI(originalDataURI, newWidth, newHeight, 'image/png').then(resizedURI => {
      //console.log('Resized image Data URI:', resizedURI);
      return resizedURI;

      /*
      filename = "thumbnail";
      const link = document.createElement("a");
      link.download = filename + ".png";
      link.href = resizedURI;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      */
    });

  };


}




/**
 * Resizes a canvas element to a specified width and returns a data URL of the resized image.
 *
 * @param {HTMLCanvasElement} canvas The canvas element to resize.
 * @param {number} newWidth The desired width for the resized canvas.
 * @param {string} type The image format for the output (e.g., 'image/png', 'image/jpeg').
 * @param {number} quality The quality of the output image (0-1, for JPEG and WEBP formats).
 * @returns {Promise<string>} A promise that resolves with the data URL of the resized image.
 */
async function resizeCanvas(canvas, newWidth, type = 'image/png', quality = 1.0) {
  return new Promise(resolve => {
    const originalWidth = canvas.width;
    const originalHeight = canvas.height;
    const newHeight = (originalHeight / originalWidth) * newWidth;

    const offscreenCanvas = document.createElement('canvas');
    offscreenCanvas.width = newWidth;
    offscreenCanvas.height = newHeight;
    const ctx = offscreenCanvas.getContext('2d');
    ctx.drawImage(canvas, 0, 0, newWidth, newHeight);

    resolve(offscreenCanvas.toDataURL(type, quality));
  });
}

/**
 * Creates a 200px wide thumbnail from a canvas element.
 *
 * @param {HTMLCanvasElement} canvas The canvas element to create a thumbnail from.
 * @returns {Promise<string>} A promise that resolves with the data URL of the 200px thumbnail.
 */
async function createThumbnail(canvas) {
  return resizeCanvas(canvas, 200);
}

// Example usage:
// Assumes you have a canvas element with an id 'myCanvas'
// const myCanvas = document.getElementById('myCanvas');
// createThumbnail(myCanvas).then(thumbnailUrl => {
//   console.log('Thumbnail data URL:', thumbnailUrl);
//   // You can now use thumbnailUrl to display the thumbnail, e.g.,
//   // const img = new Image();
//   // img.src = thumbnailUrl;
//   // document.body.appendChild(img);
// });






//The set of functions that I want to call in order





function getMemoryImage(layerJson) {
  console.log("getMemoryImage", layerJson);

  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      layerJson.image = img;
      resolve(layerJson); // Resolve the promise with the loaded Image object
    };

    img.onerror = (error) => {
      reject(new Error(`Failed to load image from Data URI: ${error}`)); // Reject the promise on error
    };

    img.src = layerJson.image; // Set the source to the Data URI to trigger loading
  });
}


function parseImage(layerJson) {
  console.log("parseImage", layerJson);

  //does some stuff with the data
  return new Promise(function (resolve, reject) {
    var width = layerJson.image.width;
    var height = layerJson.image.height;
    //console.log("getImageDataURIDimensions", {"width": width, "height": height});

    let originalWidth = width;
    let originalHeight = height;

    let maxWidth = 200; // Example: desired maximum width
    let newWidth = originalWidth;
    let newHeight = originalHeight;

    //console.log("originalWidth, maxWidth", originalWidth, maxWidth);
    // If the image is wider than the max width
    if (originalWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = (originalHeight * maxWidth) / originalWidth;
    }
    //console.log("newWidth, newHeight", newWidth, newHeight);

    layerJson.imageWidth = newWidth;
    layerJson.imageHeight = newHeight;

    resolve(layerJson);
  })
}

function createThumb(layerJson) {
  console.log("createThumb", layerJson);

  //validates the data
  return new Promise(function (resolve, reject) {
    const canvas = document.createElement('canvas');
    canvas.width = layerJson.imageWidth;
    canvas.height = layerJson.imageHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(layerJson.image, 0, 0, layerJson.imageWidth, layerJson.imageHeight);
    resizedDataURI = canvas.toDataURL('image/png', 100);
    layerJson.image = resizedDataURI;

    resolve(layerJson);
  });
}


function saveThumb(layerJson) {
  //debugger;
  console.log("saveThumb - typeof", typeof layerJson);
  console.log("saveThumb - layerJson", layerJson);
  let name = layerJson.name;
  //var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(layerJson);
  var dataStr = JSON.stringify(layerJson);
  console.log("saveThumb - dataStr", dataStr);
  saveDesign(designNamePrefix + layerJson.name, dataStr);
}


//The function that orchestrates these calls 
function thumbRunner(layerJson) {
  console.log("thumbRunner", layerJson);

  return getMemoryImage(layerJson)
    .then(parseImage)
    .then(createThumb)
    .then(saveThumb)
}



function addTrackImage(imageUrl, dataset = {}) {
  Konva.Image.fromURL(imageUrl, function (imgNode) {
    // imgNode is the ready-to-use Konva.Image instance
    imgNode.setAttrs({
      x: 100,
      y: 100,
      width: imgNode.width(), // * (72/96),
      height: imgNode.height(), // * (72/96),
      draggable: false,
      isFlipped: false,
      name: imageUrl,
      type: dataset.type,
      group: dataset.group,
      numberLanes: dataset.lanes,
      sortable: dataset.group === "Tracks" ? false : true,
    });
    imgNode.className = "Track";
    layer.add(imgNode);
    layer.batchDraw();  // Or layer.draw() to update the canvas
  }, function (err) {
    console.error('Error loading image:', err);
  });
}


function loadImage(url) {
  return new Promise((resolve, reject) => {
    const imageObj = new Image();
    imageObj.onload = () => resolve(imageObj);
    imageObj.onerror = (error) => reject(error);
    imageObj.src = url;
  });
}


async function addImageToKonvaLayer(imageUrl, konvaLayer) {
  try {
    const loadedImage = await loadImage(imageUrl);
    console.log("addImageToKonvaLayer", loadedImage);
    // Create a Konva.Image shape with the loaded image
    const konvaImage = new Konva.Image({
      image: loadedImage,
      x: 50, // Example position
      y: 50,
      width: loadedImage.width,
      height: loadedImage.height,
    });

    // Add the Konva.Image to the Konva layer
    konvaLayer.add(konvaImage);
    konvaLayer.batchDraw(); // Redraw the layer to display the image

  } catch (error) {
    console.error('Error loading image:', error);
  }
}


function getDesignLayerPrices() {
  let layers = new Array();
  let textCount = 0;
  let base_price = getBoard().base_price;
  let final_price = 0;

  layers.push({
    "layer": "base",
    "type": "board",
    "cost": base_price
  });

  for (let l = 0; l < layer.children.length; l++) {
    if (layer.children[l].attrs.type == "image" ||
      layer.children[l].attrs.type == "svgobject" ||
      (layer.children[l].attrs.type == "text" || layer.children[l].attrs.type == "textpath")) {
      layers.push({
        "layer": l,
        "type": layer.children[l].attrs.type,
        "group": layer.children[l].attrs.group,
        "cost": calculateLayerCost(l),
      });
    }
  }

  return layers;
}


function calculateDesignCost() {
  let layers = new Array();
  let textCount = 0;
  let base_price = getBoard().base_price + (getBoard().board_foot * boardDimensions.boardFeet.total);
  let final_price = 0;

  layers.push({
    "layer": "base",
    "type": "board",
    "cost": base_price
  });

  const processNode = (node) => {
    if (node.getClassName() === 'Group' && node.children) {
      node.children.forEach(child => processNode(child));
      return;
    }

    if (node.attrs.type == "image" ||
      node.attrs.type == "svgobject" ||
      node.attrs.type == "svgupload" ||
      ((node.attrs.type == "text" || node.attrs.type == "textpath") && textCount++ >= textFree)) {
      layers.push({
        "layer": node._id,
        "type": node.attrs.type,
        "group": node.attrs.group,
        "cost": calculateLayerCost(node),
      });
    }
  };

  layer.children.forEach(child => processNode(child));

  console.log("Layer Costs", layers);

  for (let l = 0; l < layers.length; l++) {
    final_price += layers[l].cost;
  }

  return final_price;
}


function calculateLayerCost(node) {
  let ret = 0;

  //console.log("calculateLayerCost", items);

  if (node.getAttr('group') !== "Tracks") {
    let width = node.getWidth() * node.getScaleX() / getBaseLayerScale() / DPI;
    let height = node.getHeight() * node.getScaleY() / getBaseLayerScale() / DPI;
    ret = Math.abs(Math.round((width * height * CPM), 2));
  } else {
    let lanes = parseInt(node.getAttr('numberLanes'));
    if (isNaN(lanes)) {
      lanes = 4;
    }
    ret = lanes * perLane;
  }

  return ret;
}


document.getElementById("estimate_price").addEventListener("click", (event) => {
  let price = calculateDesignCost();

  const formatterUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  const formattedUSD = formatterUSD.format(price);

  showMessage("Estimated Price", "Estimated price to build this customized Cribbage Board is " + formattedUSD);
});



function makeStringHorizontal(str) {
  let cleanedString = str.replace(/(\r\n|\n|\r)/gm, "");
  return cleanedString;
}

function makeStringVertical(str) {
  let verticalString = str;

  if (!hasLinefeed(str)) {
    verticalString = str.split('').join('\n');
  }

  return verticalString;
}

function hasLinefeed(str) {
  return str.includes('\n');
}

document.getElementById("textDirection").addEventListener("change", function () {
  let obj = getSelectedNode();
  let newDir = document.getElementById("textDirection").value;
  //console.log("text Direction", obj, newDir, obj.getText());

  if (obj && obj.attrs.type == "text") {
    obj.attrs.direction = newDir;

    if (obj.attrs.direction == "Horizontal") {
      obj.setText(makeStringHorizontal(obj.getText()));
    } else if (obj.attrs.direction == "Vertical") {
      obj.setText(makeStringVertical(obj.getText()));
    }

    //console.log("text set", obj.getText());
  }
});


//layer.children[3].text(makeStringVertical(layer.children[3].text()))
//layer.children[3].text(makeStringHorizontal(layer.children[3].text()))


function showMessage(label, copy) {
  let dialogEl = document.getElementById("messageDialog");
  let labelEl = dialogEl.querySelector("#messageLabel");
  let copyEl = dialogEl.querySelector("#messageCopy");

  labelEl.innerHTML = "<b>" + label + "</b>";
  copyEl.innerHTML = "<p>" + copy + "<br><br></p>";

  dialogEl.showModal();
}



function applyStain(color) {
  stainFilters.forEach(stain => {
    if (stain.name == color) {
      let node = getBaseLayer();

      /*
      let node = selectedNode;
      if (!node) {
        node = getBaseLayer();
      }
      */

      node.filters([]);
      layer.batchDraw()
      node.cache();

      if (color !== "Clear") {
        node.filters([Konva.Filters.RGB]);
        node.red(stain.red);
        node.blue(stain.blue);
        node.green(stain.green);
      }
    }
  });
}

function loadStains() {
  let dialog = document.getElementById("stainDialog");
  let copyBlock = document.querySelector("#stainDialog #messageCopy");

  stainFilters.forEach(stain => {
    let link = document.createElement('a');
    link.setAttribute("data-color", stain.name);
    link.classList.add('stain-link');
    link.innerHTML = stain.name;

    link.addEventListener('click', function () {
      applyStain(stain.name);
    });

    copyBlock.appendChild(link);
  });

}

document.getElementById("edit_stain").addEventListener("click", function () {
  document.getElementById("stainDialog").showModal();
});





function moveItemPosition(direction, count) {
  let sel = getSelectedNode();

  if (sel) {
    switch (direction) {
      case "left":
        sel.setX(sel.getX() - count);
        break;
      case "right":
        sel.setX(sel.getX() + count);
        break;
      case "up":
        sel.setY(sel.getY() - count);
        break;
      case "down":
        sel.setY(sel.getY() + count);
        break;
    }
    layer.batchDraw();
  }
}

function processCountClick(event, fastEl) {
  let count = 1;
  if (event.shiftKey || fastEl.checked) {
    count = 10;
  }
  return count;
}

function processCountClickNegative(event, fastEl) {
  let count = -1;
  if (event.shiftKey || fastEl.checked) {
    count = -10;
  }
  return count;
}

addMultipleEventListener(document.getElementById('moveLeft'), "click touch", handleMoveLeftButtonClick);
function handleMoveLeftButtonClick(event) {
  moveItemPosition('left', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveLeft'), "mousedown touchstart", handleMoveLeftButtonPress);
function handleMoveLeftButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'left', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveRight'), "click touch", handleMoveRightButtonClick);
function handleMoveRightButtonClick(event) {
  moveItemPosition('right', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveRight'), "mousedown touchstart", handleMoveRightButtonPress);
function handleMoveRightButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'right', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveUp'), "click touch", handleMoveUpButtonClick);
function handleMoveUpButtonClick(event) {
  moveItemPosition('up', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveUp'), "mousedown touchstart", handleMoveUpButtonPress);
function handleMoveUpButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'up', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveDown'), "click touch", handleMoveDownButtonClick);
function handleMoveDownButtonClick(event) {
  moveItemPosition('down', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveDown'), "mousedown touchstart", handleMoveDownButtonPress);
function handleMoveDownButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'down', processCountClick(event, document.getElementById('moveFast')));
}




function updateRadius(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.radius(sel.radius() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlus'), "click touch", handleRadiusPlusButtonClick);
function handleRadiusPlusButtonClick(event) {
  updateRadius(processCountClick(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusPlus'), "mousedown touchstart", handleRadiusPlusButtonPress);
function handleRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateRadius, 100, processCountClick(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusMinus'), "click touch", handleRadiusMinusButtonClick);
function handleRadiusMinusButtonClick(event) {
  updateRadius(processCountClickNegative(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusMinus'), "mousedown touchstart", handleRadiusMinusButtonPress);
function handleRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateRadius, 100, processCountClickNegative(event, document.getElementById('radiusFast')));
}




function updateRadiusX(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.radiusX(sel.radiusX() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlusX'), "click touch", handleRadiusPlusXButtonClick);
function handleRadiusPlusXButtonClick(event) {
  updateRadiusX(processCountClick(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusPlusX'), "mousedown touchstart", handleRadiusPlusXButtonPress);
function handleRadiusPlusXButtonPress(event) {
  intervalId = setInterval(updateRadiusX, 100, processCountClick(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusX'), "click touch", handleRadiusMinusXButtonClick);
function handleRadiusMinusXButtonClick(event) {
  updateRadiusX(processCountClickNegative(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusX'), "mousedown touchstart", handleRadiusMinusXButtonPress);
function handleRadiusMinusXButtonPress(event) {
  intervalId = setInterval(updateRadiusX, 100, processCountClickNegative(event, document.getElementById('radiusXFast')));
}




function updateRadiusY(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.radiusY(sel.radiusY() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlusY'), "click touch", handleRadiusPlusYButtonClick);
function handleRadiusPlusYButtonClick(event) {
  updateRadiusY(processCountClick(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusPlusY'), "mousedown touchstart", handleRadiusPlusYButtonPress);
function handleRadiusPlusYButtonPress(event) {
  intervalId = setInterval(updateRadiusY, 100, processCountClick(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusY'), "click touch", handleRadiusMinusYButtonClick);
function handleRadiusMinusYButtonClick(event) {
  updateRadiusY(processCountClickNegative(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusY'), "mousedown touchstart", handleRadiusMinusYButtonPress);
function handleRadiusMinusYButtonPress(event) {
  intervalId = setInterval(updateRadiusY, 100, processCountClickNegative(event, document.getElementById('radiusYFast')));
}




function updateOuterRadius(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.setOuterRadius(sel.getOuterRadius() + count);
    //layer.batchDraw();
  }
}

addMultipleEventListener(document.getElementById('outerRadiusPlus'), "click touch", handleOuterRadiusPlusButtonClick);
function handleOuterRadiusPlusButtonClick(event) {
  updateOuterRadius(processCountClick(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusPlus'), "mousedown touchstart", handleOuterRadiusPlusButtonPress);
function handleOuterRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateOuterRadius, 100, processCountClick(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusMinus'), "click touch", handleOuterRadiusMinusButtonClick);
function handleOuterRadiusMinusButtonClick(event) {
  updateOuterRadius(processCountClickNegative(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusMinus'), "mousedown touchstart", handleOuterRadiusMinusButtonPress);
function handleOuterRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateOuterRadius, 100, processCountClickNegative(event, document.getElementById('outerRadiusFast')));
}




function updateInnerRadius(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.setInnerRadius(sel.getInnerRadius() + count);
    //layer.batchDraw();
  }
}

addMultipleEventListener(document.getElementById('innerRadiusPlus'), "click touch", handleInnerRadiusPlusButtonClick);
function handleInnerRadiusPlusButtonClick(event) {
  updateInnerRadius(processCountClick(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusPlus'), "mousedown touchstart", handleInnerRadiusPlusButtonPress);
function handleInnerRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateInnerRadius, 100, processCountClick(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusMinus'), "click touch", handleInnerRadiusMinusButtonClick);
function handleInnerRadiusMinusButtonClick(event) {
  updateInnerRadius(processCountClickNegative(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusMinus'), "mousedown touchstart", handleInnerRadiusMinusButtonPress);
function handleInnerRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateInnerRadius, 100, processCountClickNegative(event, document.getElementById('innerRadiusFast')));
}




function updateRectangleWidth(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.rectangleWidth(sel.rectangleWidth() + count);
    //layer.batchDraw();
  }
}

addMultipleEventListener(document.getElementById('rectangleWidthPlus'), "click touch", handleRectangleWidthPlusButtonClick);
function handleRectangleWidthPlusButtonClick(event) {
  updateRectangleWidth(processCountClick(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthPlus'), "mousedown touchstart", handleRectangleWidthPlusButtonPress);
function handleRectangleWidthPlusButtonPress(event) {
  intervalId = setInterval(updateRectangleWidth, 100, processCountClick(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthMinus'), "click touch", handleRectangleWidthMinusButtonClick);
function handleRectangleWidthMinusButtonClick(event) {
  updateRectangleWidth(processCountClickNegative(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthMinus'), "mousedown touchstart", handleRectangleWidthMinusButtonPress);
function handleRectangleWidthMinusButtonPress(event) {
  intervalId = setInterval(updateRectangleWidth, 100, processCountClickNegative(event, document.getElementById('rectangleWidthFast')));
}




function updateRectangleHeight(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.rectangleHeight(sel.rectangleHeight() + count);
    layer.batchDraw();
  }
}

addMultipleEventListener(document.getElementById('rectangleHeightPlus'), "click touch", handleRectangleHeightPlusButtonClick);
function handleRectangleHeightPlusButtonClick(event) {
  updateRectangleHeight(processCountClick(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightPlus'), "mousedown touchstart", handleRectangleHeightPlusButtonPress);
function handleRectangleHeightPlusButtonPress(event) {
  intervalId = setInterval(updateRectangleHeight, 100, processCountClick(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightMinus'), "click touch", handleRectangleHeightMinusButtonClick);
function handleRectangleHeightMinusButtonClick(event) {
  updateRectangleHeight(processCountClickNegative(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightMinus'), "mousedown touchstart", handleRectangleHeightMinusButtonPress);
function handleRectangleHeightMinusButtonPress(event) {
  intervalId = setInterval(updateRectangleHeight, 100, processCountClickNegative(event, document.getElementById('rectangleHeightFast')));
}




function rectangleRadiusUpdated() {
  let radius = parseInt(document.getElementById("rectangleRadius").value);
  let sel = getSelectedNode();

  if (sel) {
    if (sel.getClassName() === "Rect") {
      sel.cornerRadius(radius);
    } else {
      sel.rectangleRadius(radius);
      layer.batchDraw();
    }
  }
}


function strokeWidthUpdated() {
  let strokeWidth = parseInt(document.getElementById("strokeWidth").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.strokeWidth(strokeWidth);
  }
}


function filledUpdated() {
  let filled = document.getElementById("filledInput").checked;
  let sel = getSelectedNode();

  if (sel) {
    if (filled) {
      sel.fill(engraveColor);
    } else {
      sel.fill(transparentColor);
    }
  }
}


function pointerWidthUpdated() {
  let pointerWidth = parseInt(document.getElementById("pointerWidthInput").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.pointerWidth(pointerWidth);
  }
}


function pointerLengthUpdated() {
  let pointerLength = parseInt(document.getElementById("pointerLengthInput").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.pointerLength(pointerLength);
  }
}


function startRadiusUpdated() {
  let startRadius = parseInt(document.getElementById("startRadiusInput").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.startRadius(startRadius);
  }
}


function endRadiusUpdated() {
  let endRadius = parseInt(document.getElementById("endRadiusInput").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.endRadius(endRadius);
  }
}


function revolutionsUpdated() {
  let revolutions = parseInt(document.getElementById("revolutionsInput").value)
  let sel = getSelectedNode();

  if (sel) {
    sel.revolutions(revolutions);
  }
}


function updateWidth(count) {
  let sel = getSelectedNode();

  if (sel) {
    if (sel.getClassName() !== "Arrow") {
      sel.width(sel.width() + count);
    } else {
      sel.setPoints([0, 0, sel.getPoints()[2] + count, 0]);
    }
    //layer.batchDraw();
  }
}

addMultipleEventListener(document.getElementById('widthPlus'), "click touch", handleWidthPlusButtonClick);
function handleWidthPlusButtonClick(event) {
  updateWidth(processCountClick(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthPlus'), "mousedown touchstart", handleWidthPlusButtonPress);
function handleWidthPlusButtonPress(event) {
  intervalId = setInterval(updateWidth, 100, processCountClick(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthMinus'), "click touch", handleWidthMinusButtonClick);
function handleWidthMinusButtonClick(event) {
  updateWidth(processCountClickNegative(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthMinus'), "mousedown touchstart", handleWidthMinusButtonPress);
function handleWidthMinusButtonPress(event) {
  intervalId = setInterval(updateWidth, 100, processCountClickNegative(event, document.getElementById('widthFast')));
}




function updateHeight(count) {
  let sel = getSelectedNode();

  if (sel) {
    sel.height(sel.height() + count);
    //layer.batchDraw();
  }
}
addMultipleEventListener(document.getElementById('heightPlus'), "click touch", handleHeightPlusButtonClick);
function handleHeightPlusButtonClick(event) {
  updateHeight(processCountClick(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightPlus'), "mousedown touchstart", handleHeightPlusButtonPress);
function handleHeightPlusButtonPress(event) {
  intervalId = setInterval(updateHeight, 100, processCountClick(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightMinus'), "click touch", handleHeightMinusButtonClick);
function handleHeightMinusButtonClick(event) {
  updateHeight(processCountClickNegative(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightMinus'), "mousedown touchstart", handleHeightMinusButtonPress);
function handleHeightMinusButtonPress(event) {
  intervalId = setInterval(updateHeight, 100, processCountClickNegative(event, document.getElementById('heightFast')));
}










document.querySelector('.moveItemButton').addEventListener('mouseup', function () {
  clearInterval(intervalId);
});

document.querySelector('.moveItemButton').addEventListener('mouseleave', function () {
  clearInterval(intervalId);
});


function centerRectShape(shape) {
  shape.x((layer.getWidth() - shape.getWidth()) / 2);
  shape.y((layer.getHeight() - shape.getHeight()) / 2);
}



function sidesUpdated() {
  let sel = getSelectedNode();

  if (sel && (sel.getClassName() === "SidedTextPath" || sel.getClassName() === "RegularPolygon")) {
    let sides = parseInt(document.getElementById("sidesInput").value);
    if (sides < 3) {
      sides = 3;
      document.getElementById("sidesInput").value = 3;
    }
    if (sides > 12) {
      sides = 12;
      document.getElementById("sidesInput").value = 12;
    }
    sel.sides(sides);
    layer.batchDraw();
  }
}







function groupNodes(node1, node2) {
  /*
  if (node1.getClassName() === "BaseLayer"  || 
      node1.getClassName() === "Track"      ||
      node1.getClassName() === "Group"      ||
      node2.getClassName() === "BaseLayer"  || 
      node1.getClassName() === "Track"      ||
      node2.getClassName() === "Group") {
    return;
  }
  */

  if (node1.getClassName() === "Group" || node2.getClassName() === "Group") {
    if (node1.getClassName() === "Group") {
      node2.moveTo(node1);
      selectNode(node1);
    } else {
      node1.moveTo(node2);
      selectNode(node2);
    }
  } else {
    let tg = new Konva.Group({ draggable: true })

    node1.moveTo(tg);
    node2.moveTo(tg);
    transformer.nodes([tg]);

    tg.children.forEach(child => {
      child.attrs.draggable = false;
      child.setDraggable(false);
    });

    layer.add(tg)
    selectNode(tg);
  }
}

function ungroupNode(node) {

  console.log("ungroupNode", node);

  if (node && node.getClassName() === "Group" && node.children.length) {
    const children = [...node.children];

    children.forEach(child => {
      child.attrs.draggable = true;
      child.setDraggable(true);

      const absolutePosition = child.getAbsolutePosition();
      child.moveTo(layer);
      child.setAbsolutePosition(absolutePosition);
    });

    if (node === selectedNode) {
      selectNode(null);
    }

    node.destroy();
    layer.batchDraw();

    updateLayers();
  }
}




function pointsUpdated() {
  let sel = getSelectedNode();

  if (sel && (selectedNode.getClassName() === "StarTextPath" || selectedNode.getClassName() === "Star")) {
    let points = parseInt(document.getElementById("pointsInput").value);

    if (points < 2) {
      points = 2;
      document.getElementById("pointsInput").value = 2;
    }
    if (points > 12) {
      points = 12;
      document.getElementById("pointsInput").value = 12;
    }

    if (selectedNode.getClassName() === "StarTextPath") {
      sel.points(points);
    } else {
      sel.setNumPoints(points);
    }
    layer.batchDraw();
  }
}


function alignTop() {
  let min_y = Infinity;

  if (selectedNode.getClassName() === "Group") {
    // Find the minimum y-coordinate among all selected shapes
    selectedNode.children.forEach(shape => {
      min_y = Math.min(min_y, shape.y());
    });

    // Set the y-coordinate of each shape to the minimum y-coordinate
    selectedNode.children.forEach(shape => {
      shape.y(min_y - shape.getSelfRect().height);
    });
  }
}


function alignBottom() {
  let maxBottom = 0;

  if (selectedNode.getClassName() === "Group") {
    selectedNode.children.forEach(shape => {
      const shapeBottom = shape.y() + shape.height();
      if (shapeBottom > maxBottom) {
        maxBottom = shapeBottom;
      }
    });

    selectedNode.children.forEach(shape => {
      shape.y(maxBottom - shape.height());
    });
  }
}


function alignLeft() {
  let min_x = Infinity;

  if (selectedNode.getClassName() === "Group") {
    // Find the minimum y-coordinate among all selected shapes
    selectedNode.children.forEach(shape => {
      min_x = Math.min(min_x, shape.x());
    });

    // Set the y-coordinate of each shape to the minimum y-coordinate
    selectedNode.children.forEach(shape => {
      shape.x(min_x);
    });
  }
}


function alignRight() {
  let maxRight = 0;

  if (selectedNode.getClassName() === "Group") {
    selectedNode.children.forEach(shape => {
      const shapeRight = shape.x() + shape.width();
      if (shapeRight > maxRight) {
        maxRight = shapeRight;
      }
    });

    selectedNode.children.forEach(shape => {
      shape.y(maxRight - shape.width());
    });
  }
}


function getSortableNodes() {
  //let sortable = layer.children.filter(node => node.attrs.sortable === true);
  let sortable = layer.children.filter(node => node.getClassName() !== "Transformer" && node.attrs.type !== "baseImage");
  return sortable;
}


function getTransformersNodes() {
  let transformers = layer.children.filter(node => node.getClassName() === "Transformer");
  return transformers;
}


function countTransformersNodes() {
  return getTransformersNodes().length;
}


function getNextNodePos() {
  let pos = layer.children.length - countTransformersNodes() - 1;
  if (pos < 0) {
    pos = 0;
  }

  return pos;
}


function getTrackNode() {
  var matched = layer.getChildren(function (node) {
    return node.attrs.type === "svgobject" && node.attrs.group === "Tracks";
    //return node.getClassName() === "Track";
  });

  if (matched && matched.length) {
    matched = matched[0];
  } else {
    matched = null;
  }

  return matched;
}


function getBaseNode() {
  var matched = layer.getChildren(function (node) {
    return node.getClassName() === "Image" && node.attrs.type === "baseImage";
    //return node.getClassName() === "BaseLayer";
  });

  if (matched && matched.length) {
    matched = matched[0];
  } else {
    matched = null;
  }

  return matched;
}


function canMoveNodeDown(node) {
  return node.zIndex() > 1;
}

function canMoveNodeUp(node) {
  return node.zIndex() != 0 && ((node.zIndex() + 1) < (layer.children.length - countTransformersNodes()));
}


function moveNodeDown(node) {
  if (canMoveNodeDown(node)) {
    node.zIndex(node.zIndex() - 1);
  }
}


function moveNodeUp(node) {
  if (canMoveNodeUp(node)) {
    node.zIndex(node.zIndex() + 1);
  }
}


function moveSelectedNodeDown() {
  moveNodeDown(selectedNode);
}


function moveSelectedNodeUp() {
  moveNodeUp(selectedNode);
}




function updateLayers() {
  let items = getSortableNodes();
  console.log("updateLayers", items);

  const listContainer = document.querySelector('.layerListContainer');

  // Dynamically create list items from the array
  listContainer.innerHTML = '';
  let layerIdx = 1;

  const addItems = (nodes, container, level = 0) => {
    nodes.forEach(item => {
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.classList.add('layer-group-wrapper');
      wrapper.setAttribute('draggable', level === 0 ? 'true' : 'false');
      wrapper.setAttribute('data-id', item._id);

      const listItem = document.createElement('div');
      listItem.classList.add('list-item-layer');
      //listItem.setAttribute('draggable', 'true'); // Wrapper is now draggable
      listItem.setAttribute('data-id', item._id);

      // Indentation
      listItem.style.marginLeft = (level * 20) + 'px';

      let visible = item.visible() == true ? "" : "layer-hidden";
      let isText = item.copySVGDataToClipboard != undefined ? "" : "hidden";
      let visible_class = item.visible() == true ? "visibility" : "visibility_off";

      listItem.innerHTML = `
          <span class="material-icons drag-handle-layer">drag_indicator</span>
          <span class="item-text-layer">${item.getClassName()} ($${calculateLayerCost(item)})</span>
          <span class="material-icons copyto-clipboard-btn-layer ${isText}" title="Copy SVG To Clipboard">content_paste</span>
          <span class="material-icons toggle-visibility-layer ${visible}" title="Toggle Visibility">${visible_class}</span>
          <span class="material-icons delete-btn-layer" title="Delete Layer">delete</span>
      `;
      wrapper.appendChild(listItem);

      // Container for children
      const childrenContainer = document.createElement('div');
      childrenContainer.classList.add('layer-children');
      wrapper.appendChild(childrenContainer);

      container.appendChild(wrapper);

      if (item.getClassName() === 'Group' && item.children) {
        addItems(item.children, childrenContainer, level + 1);
      }

      layerIdx++;
    });
  }

  addItems(items, listContainer);

  const listItems = document.querySelectorAll('.list-item-layer');
  const wrappers = document.querySelectorAll('.layer-group-wrapper');
  let draggedItem = null;
  let selectedItem = null;

  // Selection Logic (remains on list-item-layer)
  listItems.forEach(item => {
    item.addEventListener('click', (e) => {
      if (e.target.classList.contains('delete-btn-layer') ||
        e.target.classList.contains('copyto-clipboard-btn-layer') ||
        e.target.classList.contains('drag-handle-layer') ||
        e.target.classList.contains('toggle-visibility-layer'))
        return;

      if (selectedItem) {
        selectedItem.classList.remove('selected');
      }
      item.classList.add('selected');
      selectNodeById(parseInt(item.getAttribute("data-id")));
      selectedItem = item;
    });

    // Delete functionality
    const deleteBtn = item.querySelector('.delete-btn-layer');
    deleteBtn.addEventListener('click', () => {
      if (item === selectedItem) {
        selectedItem = null;
      }
      deleteNodeById(parseInt(item.getAttribute("data-id")));
      item.closest('.layer-group-wrapper').remove();
    });

    // Copy SVG data to clipboard functionality
    const copySVGBtn = item.querySelector('.copyto-clipboard-btn-layer');
    copySVGBtn.addEventListener('click', () => {
      let curNode = getNodeById(parseInt(item.getAttribute("data-id")));

      if (curNode && curNode.copySVGDataToClipboard) {
        curNode.copySVGDataToClipboard();
      }
    });

    // Visibility toggle functionality
    const toggleBtn = item.querySelector('.toggle-visibility-layer');
    toggleBtn.addEventListener('click', () => {
      toggleBtn.classList.toggle('layer-hidden');
      toggleBtn.innerText = toggleBtn.innerText === "visibility" ? "visibility_off" : "visibility";

      let curNode = getNodeById(parseInt(item.getAttribute("data-id")));
      if (curNode) {
        if (curNode.visible() === true) {
          curNode.hide();
        } else {
          curNode.show();
        }
      }
    });

  });

  // Drag and drop functionality (on wrappers)
  wrappers.forEach(item => {
    item.addEventListener('dragstart', (e) => {
      e.stopPropagation(); // Prevent bubbling
      draggedItem = item;
      // Select content
      const content = item.querySelector('.list-item-layer');
      if (selectedItem) selectedItem.classList.remove('selected');
      if (content) {
        content.classList.add('selected');
        selectedItem = content;
      }

      setTimeout(() => {
        item.classList.add('dragging');
      }, 0);
    });

    item.addEventListener('dragend', () => {
      item.classList.remove('dragging');

      // Re-sort Konva nodes
      const syncOrder = (container) => {
        Array.from(container.children).forEach(wrapper => {
          if (wrapper.classList.contains('layer-group-wrapper')) {
            const id = parseInt(wrapper.getAttribute('data-id'));
            const node = getNodeById(id);
            if (node) {
              // Logic: 
              // 1. Identify new parent (Konva Layer or Group) based on DOM
              const parentContainer = wrapper.parentElement;
              let newParent = layer; // Default
              if (parentContainer.classList.contains('layer-children')) {
                // Parent is a group
                const parentWrapper = parentContainer.closest('.layer-group-wrapper');
                const parentId = parseInt(parentWrapper.getAttribute('data-id'));
                newParent = getNodeById(parentId);
              }

              // 2. Move to new parent (handles reparenting)
              if (node.getParent() !== newParent) {
                node.moveTo(newParent);
              }

              // 3. Move to bottom (which is effectively "next" in draw order)
              // Since we traverse DOM top-to-bottom, this sorts them correctly.
              node.moveToTop();

              // Recurse
              const childrenContainer = wrapper.querySelector('.layer-children');
              if (childrenContainer) {
                syncOrder(childrenContainer);
              }
            }
          }
        });
      };

      syncOrder(listContainer);
      layer.batchDraw();
      draggedItem = null;
    });

    item.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });

    item.addEventListener('dragenter', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Logic for insertion
      const targetWrapper = e.target.closest('.layer-group-wrapper');
      if (targetWrapper && targetWrapper !== draggedItem && !draggedItem.contains(targetWrapper)) {
        // Simple insertion before/after logic
        // To allow dropping "inside", we might need hit testing or zones.
        // For now, let's assume dropping *on* a wrapper puts it before/after (sibling).

        const bounding = targetWrapper.getBoundingClientRect();
        const offset = bounding.y + (bounding.height / 2);
        const parent = targetWrapper.parentNode;

        if (e.clientY - offset > 0) {
          parent.insertBefore(draggedItem, targetWrapper.nextSibling);
        } else {
          parent.insertBefore(draggedItem, targetWrapper);
        }
      }
    });
  });
}




const dialog = document.getElementById('layerDialog');
const dialogHeader = dialog.querySelector('.dialog-label');

// Dialog drag functionality
let isDraggingDialog = false;
let currentX = 0;
let currentY = 0;
let initialX;
let initialY;

dialogHeader.addEventListener('mousedown', (e) => {
  initialX = e.clientX - currentX;
  initialY = e.clientY - currentY;
  isDraggingDialog = true;
  dialog.style.cursor = 'grabbing';
  e.preventDefault(); // Prevent text selection
});

document.addEventListener('mousemove', (e) => {
  if (isDraggingDialog) {
    e.preventDefault(); // Prevent interference with list item drag
    const newX = e.clientX - initialX;
    const newY = e.clientY - initialY;

    // Use requestAnimationFrame for smoother updates
    requestAnimationFrame(() => {
      currentX = newX;
      currentY = newY;
      dialog.style.transform = `translate(${currentX}px, ${currentY}px)`;
    });
  }
});

document.addEventListener('mouseup', () => {
  isDraggingDialog = false;
  dialog.style.cursor = 'auto';
});

// Initialize dialog position
//dialog.style.position = 'absolute';
//dialog.style.transform = `translate(${currentX}px, ${currentY}px)`;







const sidebar = document.getElementById('sidebar');
const toggleBtn = document.getElementById('toggleBtn');
const expandAll = document.getElementById('expandAll');
const themeToggle = document.getElementById('themeToggle');
const html = document.documentElement;

// Dark Mode
const saved = localStorage.getItem('theme') || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
html.dataset.theme = saved;
themeToggle.innerHTML = saved === 'dark' ? '<i class="fas fa-sun"></i>' : '<i class="fas fa-moon"></i>';

themeToggle.onclick = () => {
  const isDark = html.dataset.theme === 'dark';
  const newTheme = isDark ? 'light' : 'dark';
  html.dataset.theme = newTheme;
  localStorage.setItem('theme', newTheme);
  themeToggle.innerHTML = newTheme === 'dark' ? '<i class="fas fa-sun"></i>' : '<i class="fas fa-moon"></i>';
};

// Sidebar Toggle
toggleBtn.onclick = () => {
  sidebar.classList.toggle('collapsed');
  toggleBtn.innerHTML = sidebar.classList.contains('collapsed') ? '<i class="fas fa-times"></i>' : '<i class="fas fa-bars"></i>';
};

// Accordion + Auto-Expand
document.querySelectorAll('.accordion-title').forEach(h => {
  h.onclick = () => {
    const body = document.getElementById(h.dataset.target);
    const open = !body.classList.contains('open');
    body.classList.toggle('open');
    h.classList.toggle('open');
    if (open && sidebar.classList.contains('collapsed')) {
      sidebar.classList.remove('collapsed');
      toggleBtn.innerHTML = '<i class="fas fa-bars"></i>';
    }
  };
});

// Expand All
let expanded = false;
expandAll.onclick = () => {
  expanded = !expanded;
  document.querySelectorAll('.accordion-body').forEach(b => b.classList.toggle('open', expanded));
  document.querySelectorAll('.accordion-title').forEach(h => h.classList.toggle('open', expanded));
  expandAll.innerHTML = expanded ? '<i class="fas fa-compress-arrows-alt"></i>' : '<i class="fas fa-expand-arrows-alt"></i>';
  if (expanded && sidebar.classList.contains('collapsed')) {
    sidebar.classList.remove('collapsed');
    toggleBtn.innerHTML = '<i class="fas fa-bars"></i>';
  }
};

// Form Demo
document.querySelector('.form-demo')?.addEventListener('submit', e => {
  e.preventDefault();
  alert('Form submitted!');
});




function pegSizeUpdated(size) {
  let ps = pegSizes.find(p => p.name === size);

  if (ps && ps.scale) {
    selectedNode.scale({ x: ps.scale, y: ps.scale });
  }
}


function getPegSizeFromScale(scale) {
  let ret = "";

  pegSizes.forEach(p => {
    if (p.scale === scale) {
      ret = p.name;
    }
  });

  return ret;
}





// Collect all possible guide lines (stage borders, center, and all object edges/centers)
function getLineGuideStops(skipShape) {
  const vertical = [0, stage.width() / 2, stage.width()];
  const horizontal = [0, stage.height() / 2, stage.height()];

  //stage.find('.object').forEach((guideItem) => {
  getSortableNodes().forEach((guideItem) => {
    if (guideItem === skipShape) return;
    const box = guideItem.getClientRect();
    vertical.push(box.x, box.x + box.width, box.x + box.width / 2);
    horizontal.push(box.y, box.y + box.height, box.y + box.height / 2);
  });

  return { vertical: vertical.flat(), horizontal: horizontal.flat() };
}

// Snapping edges/center of the dragged node
function getObjectSnappingEdges(node) {
  const box = node.getClientRect();
  const absPos = node.absolutePosition();

  return {
    vertical: [
      { guide: Math.round(box.x), offset: Math.round(absPos.x - box.x), snap: 'start' },
      { guide: Math.round(box.x + box.width / 2), offset: Math.round(absPos.x - box.x - box.width / 2), snap: 'center' },
      { guide: Math.round(box.x + box.width), offset: Math.round(absPos.x - box.x - box.width), snap: 'end' },
    ],
    horizontal: [
      { guide: Math.round(box.y), offset: Math.round(absPos.y - box.y), snap: 'start' },
      { guide: Math.round(box.y + box.height / 2), offset: Math.round(absPos.y - box.y - box.height / 2), snap: 'center' },
      { guide: Math.round(box.y + box.height), offset: Math.round(absPos.y - box.y - box.height), snap: 'end' },
    ],
  };
}

// Find closest guides within tolerance
function getGuides(lineGuideStops, itemBounds) {
  const resultV = [];
  const resultH = [];

  lineGuideStops.vertical.forEach((lineGuide) => {
    //console.log("lineGuide", lineGuide);
    itemBounds.vertical.forEach((itemBound) => {
      const diff = Math.abs(lineGuide - itemBound.guide);
      //console.log("itemBound", itemBound, diff);
      if (diff < GUIDELINE_OFFSET) {
        //console.log("getGuides diff found");
        resultV.push({
          lineGuide,
          diff,
          snap: itemBound.snap,
          offset: itemBound.offset,
        });
      }
    });
  });

  lineGuideStops.horizontal.forEach((lineGuide) => {
    itemBounds.horizontal.forEach((itemBound) => {
      const diff = Math.abs(lineGuide - itemBound.guide);
      if (diff < GUIDELINE_OFFSET) {
        resultH.push({
          lineGuide,
          diff,
          snap: itemBound.snap,
          offset: itemBound.offset,
        });
      }
    });
  });

  //console.log("getGuides", lineGuideStops, itemBounds, resultV, resultH);

  // Pick the closest vertical and horizontal guide
  const minV = resultV.sort((a, b) => a.diff - b.diff)[0];
  const minH = resultH.sort((a, b) => a.diff - b.diff)[0];

  const guides = [];
  if (minV) guides.push({ lineGuide: minV.lineGuide, offset: minV.offset, orientation: 'V' });
  if (minH) guides.push({ lineGuide: minH.lineGuide, offset: minH.offset, orientation: 'H' });

  return guides;
}

// Draw temporary dashed guidelines
function drawGuides(guides, layer) {
  guides.forEach((lg) => {
    if (lg.orientation === 'H') {
      const line = new Konva.Line({
        points: [-6000, 0, 6000, 0],
        stroke: '#008000',
        strokeWidth: 4,
        name: 'guid-line',
        dash: [4, 6],
      });
      layer.add(line);
      line.absolutePosition({ x: 0, y: lg.lineGuide });
    } else if (lg.orientation === 'V') {
      const line = new Konva.Line({
        points: [0, -6000, 0, 6000],
        stroke: '#008000',
        strokeWidth: 4,
        name: 'guid-line',
        dash: [4, 6],
      });
      layer.add(line);
      line.absolutePosition({ x: lg.lineGuide, y: 0 });
    }
  });
}


// Drag move handler
layer.on('dragmove', (e) => {
  //console.log("dragmove", e.target);
  const target = e.target;
  //if (target.name() !== 'object') return;
  //console.log("dragmove name", target.name());

  // Remove old guidelines
  layer.find('.guid-line').forEach((l) => l.destroy());

  const lineGuideStops = getLineGuideStops(target);
  const itemBounds = getObjectSnappingEdges(target);
  const guides = getGuides(lineGuideStops, itemBounds);

  //console.log("dragmove", e.target, lineGuideStops, itemBounds, guides);

  if (guides.length) {
    drawGuides(guides, layer);

    // Snap position
    const absPos = target.absolutePosition();
    guides.forEach((lg) => {
      if (lg.orientation === 'V') absPos.x = lg.lineGuide + lg.offset;
      else if (lg.orientation === 'H') absPos.y = lg.lineGuide + lg.offset;
    });
    target.absolutePosition(absPos);
  }

  layer.batchDraw();
});

// Clean up guidelines on drag end
layer.on('dragend', () => {
  layer.find('.guid-line').forEach((l) => l.destroy());
  layer.batchDraw();
});

